import _objectWithoutProperties from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["inverse", "theme", "id", "onChange"];
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx, jsxs, Fragment } from 'theme-ui/jsx-runtime';
import { ThemeProvider } from '@theme-ui/core';
import { Button as Button$1, MDBLogo, ELogoVariant, Link, ELinkVariant, Globals } from '@mdb/flora';
import theme from '@mdb/flora/theme-legacy';
import { useState, useRef, useEffect, forwardRef, useImperativeHandle, useCallback } from 'react';
import { Box, Divider as Divider$1 } from 'theme-ui';
import { keyframes, Global } from '@emotion/react';
import defaultTheme from '@mdb/flora/theme';
import { Box as Box$1, Divider } from '@theme-ui/components';
var nav$7 = {
  primary: [{
    title: "Products",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/atlas",
            description: "Developer data platform",
            hasDivider: true
          },
          subColumns: [[{
            title: "Database",
            target: "_self",
            href: "https://www.mongodb.com/atlas/database"
          }, {
            title: "Search",
            target: "_self",
            href: "https://www.mongodb.com/atlas/search"
          }, {
            title: "Data Lake (Preview)",
            target: "_self",
            href: "https://www.mongodb.com/atlas/data-lake"
          }, {
            title: "Charts",
            target: "_self",
            href: "https://www.mongodb.com/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/products/mongodb-enterprise-advanced",
            description: "Enterprise software and support",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/products/ops-manager"
          }, {
            title: "Enterprise Kubernetes Operator",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "Community Edition",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "Free software used by millions",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/cloud/cloud-manager"
          }, {
            title: "Community Kubernetes Operator",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "Tools",
            target: "_self",
            href: "https://www.mongodb.com/developer-tools",
            description: "Build faster",
            arrow: true,
            hasDivider: true
          },
          subColumns: [[{
            title: "Compass",
            target: "_self",
            href: "https://www.mongodb.com/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/products/shell"
          }, {
            title: "VS Code Plugin",
            target: "_self",
            href: "https://www.mongodb.com/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/cloud/cli"
          }, {
            title: "Database Connectors",
            target: "_self",
            href: "https://www.mongodb.com/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/products/cluster-to-cluster-sync"
          }, {
            title: "Mongoose ODM Support",
            target: "_self",
            href: "https://www.mongodb.com/tools/mongoose"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Solutions",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "By Industry",
            hasDivider: true
          },
          subColumns: [[{
            title: "Financial Services",
            target: "_self",
            href: "https://www.mongodb.com/industries/financial-services"
          }, {
            title: "Telecom",
            target: "_self",
            href: "https://www.mongodb.com/industries/telecommunications"
          }, {
            title: "Healthcare",
            target: "_self",
            href: "https://www.mongodb.com/industries/healthcare"
          }, {
            title: "Retail",
            target: "_self",
            href: "https://www.mongodb.com/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/industries/manufacturing"
          }, {
            title: "All Industries",
            target: "_self",
            href: "https://www.mongodb.com/industries"
          }]]
        }, {
          header: {
            title: "By Use Case",
            hasDivider: true
          },
          subColumns: [[{
            title: "Analytics",
            target: "_self",
            href: "https://www.mongodb.com/use-cases/analytics"
          }, {
            title: "Internet of Things",
            target: "_self",
            href: "https://www.mongodb.com/use-cases/internet-of-things"
          }, {
            title: "Mobile",
            target: "_self",
            href: "https://www.mongodb.com/use-cases/mobile"
          }, {
            title: "Payments",
            target: "_self",
            href: "https://www.mongodb.com/use-cases/payments"
          }, {
            title: "Serverless Development",
            target: "_self",
            href: "https://www.mongodb.com/use-cases/serverless"
          }, {
            title: "All Use Cases",
            target: "_self",
            href: "https://www.mongodb.com/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "Developer Data Platform",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "Learn More",
            target: "_self",
            href: "https://www.mongodb.com/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "White Papers & Presentations",
            description: "Webinars, white papers, datasheets and more"
          },
          button: {
            title: "View All",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "Resources",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "Documentation",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "Server",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "Drivers",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "Develop Applications",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/develop-applications/"
          }, {
            title: "Launch and Manage MongoDB",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/launch-manage/"
          }, {
            title: "View and Analyze",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/view-analyze/"
          }, {
            title: "Start with Guides",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "Community",
            hasDivider: true
          },
          subColumns: [[{
            title: "Developer Center",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "Events & Webinars",
            target: "_self",
            href: "https://www.mongodb.com/events-webinars-overview"
          }, {
            title: "Forums",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "Champions",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "Find a User Group",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "Education",
            hasDivider: true
          },
          subColumns: [[{
            title: "University",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "Certification",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "Academia",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "Intro to MongoDB Course",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "Browse All Courses",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "Company",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "About",
            hasDivider: true
          },
          subColumns: [[{
            title: "Who We Are",
            target: "_self",
            href: "https://www.mongodb.com/company"
          }, {
            title: "Customer Stories",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "Blog",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "Careers",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "Pressroom",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "Leadership",
            target: "_self",
            href: "https://www.mongodb.com/leadership"
          }, {
            title: "Investors",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "Services",
            hasDivider: true
          },
          subColumns: [[{
            title: "Consulting",
            target: "_self",
            href: "https://www.mongodb.com/products/consulting"
          }, {
            title: "Training",
            target: "_self",
            href: "https://www.mongodb.com/products/training"
          }, {
            title: "Customer Support",
            target: "_self",
            href: "https://www.mongodb.com/support"
          }, {
            title: "Customer Success",
            target: "_self",
            href: "https://www.mongodb.com/customer-success"
          }]]
        }, {
          header: {
            title: "Partnerships",
            hasDivider: true
          },
          subColumns: [[{
            title: "Become a Partner",
            target: "_self",
            href: "https://www.mongodb.com/partners/partner-program"
          }, {
            title: "Find a Partner",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB for Startups",
            target: "_self",
            href: "https://www.mongodb.com/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Pricing",
    target: "_self",
    href: "https://www.mongodb.com/pricing"
  }],
  secondary: {
    "try": {
      title: "Try Free",
      target: "_self",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "Sign In",
      target: "_self",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "Search",
      options: [{
        value: "General Information",
        placeholder: "Search products, whitepapers, & more...",
        universalKey: "DOTCOM"
      }, {
        value: "All Documentation",
        placeholder: "Search all documentation...",
        universalKey: "DOCS"
      }, {
        value: "Realm Documentation",
        placeholder: "Search Realm documentation...",
        universalKey: "REALM"
      }, {
        value: "Developer Articles & Topics",
        placeholder: "Search articles and topics...",
        universalKey: "DEVHUB"
      }, {
        value: "Community Forums",
        placeholder: "Search community forums...",
        universalKey: "COMMUNITY"
      }, {
        value: "Blog",
        placeholder: "Search blog...",
        universalKey: "BLOG"
      }, {
        value: "University",
        placeholder: "Search university...",
        universalKey: "UNIVERSITY"
      }]
    }
  }
};
var footer$7 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "About",
    links: [{
      title: "Careers",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "Investor Relations",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "Legal Notices",
      target: "_self",
      href: "https://www.mongodb.com/legal/legal-notices"
    }, {
      title: "Privacy Notices",
      target: "_self",
      href: "https://www.mongodb.com/legal/privacy-policy"
    }, {
      title: "Security Information",
      target: "_self",
      href: "https://www.mongodb.com/security"
    }, {
      title: "Trust Center",
      target: "_self",
      href: "https://www.mongodb.com/cloud/trust"
    }, {
      title: "Saudi Arabian VAT Certificate",
      target: "_blank",
      href: "https://webassets.mongodb.com/_com_assets/cms/lcqodf8rajwqnn9uw-MongoBD%20VAT%20certificate_ZATCA_KSA.pdf",
      hide: true
    }]
  }, {
    title: "Support",
    links: [{
      title: "Contact Us",
      target: "_self",
      href: "https://www.mongodb.com/contact"
    }, {
      title: "Customer Portal",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Atlas Status",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "Paid Support",
      target: "_self",
      href: "https://www.mongodb.com/products/enterprise-grade-support"
    }, {
      id: "manage-cookies",
      title: "Manage Cookies",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "Social",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var enUs = {
  nav: nav$7,
  footer: footer$7
};
var nav$6 = {
  primary: [{
    title: "Produtos",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/pt-br/atlas",
            description: "Plataforma para desenvolverdores de dados",
            hasDivider: true
          },
          subColumns: [[{
            title: "Banco de dados",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/atlas/database"
          }, {
            title: "Pesquisar",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/atlas/search"
          }, {
            title: "Data Lake (Prévia)",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/atlas/data-lake"
          }, {
            title: "Gráficos",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/mongodb-enterprise-advanced",
            description: "Software e suporte enterprise",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/ops-manager"
          }, {
            title: "Operador de Kubernetes Enterprise",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "Community Edition",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "Software grátis usado por milhões de pessoas",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/cloud/cloud-manager"
          }, {
            title: "Operador de Kubernetes da comunidade",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "Ferramentas",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/developer-tools",
            description: "Desenvolva mais rápido",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "IDE do Compass",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/shell"
          }, {
            title: "Plugin VS Code",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/vs-code"
          }, {
            title: "CLI do Atlas",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/cloud/cli"
          }, {
            title: "Conectores de banco de dados",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Soluções",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Por setor",
            hasDivider: true
          },
          subColumns: [[{
            title: "Serviços financeiros",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries/financial-services"
          }, {
            title: "Telecomunicações",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries/telecommunications"
          }, {
            title: "Saúde",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries/healthcare"
          }, {
            title: "Varejo",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries/manufacturing"
          }, {
            title: "Todos os setores",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/industries"
          }]]
        }, {
          header: {
            title: "Por caso de uso",
            hasDivider: true
          },
          subColumns: [[{
            title: "Analíticas",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/use-cases/analytics"
          }, {
            title: "Internet das coisas",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/use-cases/internet-of-things"
          }, {
            title: "Dispositivos Móveis",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/use-cases/mobile"
          }, {
            title: "Pagamentos",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/use-cases/payments"
          }, {
            title: "Serverless Development",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/use-cases/serverless"
          }, {
            title: "Todos os casos de uso",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "Plataforma para desenvolverdores de dados",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "Ver tudo",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "White papers e Apresentações ",
            description: "Webinars, white papers, fichas técnicas e mais"
          },
          button: {
            title: "Ver tudo",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "Recursos",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "Documentação",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "Servidor",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "Drivers",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "Guias de Iniciante",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "Comunidade",
            hasDivider: true
          },
          subColumns: [[{
            title: "Centro de Desenvolvedores",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "Eventos e webinars",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/events-webinars-overview"
          }, {
            title: "Fóruns",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "Campeões",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "Encontre um Grupo de Usuários",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "Educação",
            hasDivider: true
          },
          subColumns: [[{
            title: "Universidade",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "Certificação",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "Academia",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "Curso Básico do MongoDB",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "Todos os cursos",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "Empresa",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Sobre",
            hasDivider: true
          },
          subColumns: [[{
            title: "Quem somos",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/company"
          }, {
            title: "Clientes",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/who-uses-mongodb"
          }, {
            title: "Blog",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "Carreiras",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "Sala de imprensa",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "Liderança",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/leadership"
          }, {
            title: "Investidores",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "Serviços",
            hasDivider: true
          },
          subColumns: [[{
            title: "Consultoria",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/consulting"
          }, {
            title: "Treinamento",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/products/training"
          }, {
            title: "Suporte Enterprise",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/support"
          }, {
            title: "Sucesso do cliente",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/customer-success"
          }]]
        }, {
          header: {
            title: "Parcerias",
            hasDivider: true
          },
          subColumns: [[{
            title: "Seja um parceiro",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/partners/partner-program"
          }, {
            title: "Encontre um parceiro",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB para Startups",
            target: "_self",
            href: "https://www.mongodb.com/pt-br/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Preços",
    target: "_self",
    href: "https://www.mongodb.com/pt-br/pricing"
  }],
  secondary: {
    "try": {
      title: "Teste Grátis",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "Logar",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "Enviar",
      options: [{
        value: "Informações gerais",
        placeholder: "Pesquise produtos, whitepapers e muito mais...",
        universalKey: "DOTCOM"
      }, {
        value: "Toda a documentação",
        placeholder: "Pesquise toda a documentação...",
        universalKey: "DOCS"
      }, {
        value: "Documentação do Realm",
        placeholder: "Pesquise a documentação do Realm...",
        universalKey: "REALM"
      }, {
        value: "Artigos e tópicos do desenvolvedor",
        placeholder: "Pesquise artigos e tópicos...",
        universalKey: "DEVHUB"
      }, {
        value: "Fóruns",
        placeholder: "Pesquise nos fóruns...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer$6 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "Sobre",
    links: [{
      title: "Carreiras",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "Investidores",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "Avisos legais",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/legal/legal-notices"
    }, {
      title: "Avisos de privacidade",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/legal/privacy-policy"
    }, {
      title: "Informações de segurança",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/security"
    }, {
      title: "Central de confiança",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/cloud/trust"
    }, {
      title: "Mapa do site",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/html-sitemap"
    }]
  }, {
    title: "Suporte",
    links: [{
      title: "Contate-nos",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/contact"
    }, {
      title: "Portal do cliente",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Status do Atlas",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "Suporte pago",
      target: "_self",
      href: "https://www.mongodb.com/pt-br/products/enterprise-grade-support"
    }]
  }, {
    title: "Social",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var ptBr = {
  nav: nav$6,
  footer: footer$6
};
var nav$5 = {
  primary: [{
    title: "Productos",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/es/atlas",
            description: "Plataforma de datos para desarrolladores",
            hasDivider: true
          },
          subColumns: [[{
            title: "Base de datos",
            target: "_self",
            href: "https://www.mongodb.com/es/atlas/database"
          }, {
            title: "Buscar",
            target: "_self",
            href: "https://www.mongodb.com/es/atlas/search"
          }, {
            title: "Data Lake (Avance)",
            target: "_self",
            href: "https://www.mongodb.com/es/atlas/data-lake"
          }, {
            title: "Charts",
            target: "_self",
            href: "https://www.mongodb.com/es/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/es/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/es/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/es/products/mongodb-enterprise-advanced",
            description: "Software y soporte para empresas",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/es/products/ops-manager"
          }, {
            title: "Operador de Kubernetes Enterprise",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "Community Edition",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "Software gratuito utilizado por millones",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/es/cloud/cloud-manager"
          }, {
            title: "Operador de Kubernetes Community",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "Herramientas",
            target: "_self",
            href: "https://www.mongodb.com/es/developer-tools",
            description: "Construir más rápidamente",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "IDE de Compass",
            target: "_self",
            href: "https://www.mongodb.com/es/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/es/products/shell"
          }, {
            title: "Plugin VS Code",
            target: "_self",
            href: "https://www.mongodb.com/es/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/es/cloud/cli"
          }, {
            title: "Conectores de bases de datos",
            target: "_self",
            href: "https://www.mongodb.com/es/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/es/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/es/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Soluciones",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Por sector",
            hasDivider: true
          },
          subColumns: [[{
            title: "Servicios financieros",
            target: "_self",
            href: "https://www.mongodb.com/es/industries/financial-services"
          }, {
            title: "Telecomunicaciones",
            target: "_self",
            href: "https://www.mongodb.com/es/industries/telecommunications"
          }, {
            title: "Salud",
            target: "_self",
            href: "https://www.mongodb.com/es/industries/healthcare"
          }, {
            title: "Comercio minorista",
            target: "_self",
            href: "https://www.mongodb.com/es/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/es/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/es/industries/manufacturing"
          }, {
            title: "Todos los sectores",
            target: "_self",
            href: "https://www.mongodb.com/es/industries"
          }]]
        }, {
          header: {
            title: "Por caso de uso",
            hasDivider: true
          },
          subColumns: [[{
            title: "Analytics",
            target: "_self",
            href: "https://www.mongodb.com/es/use-cases/analytics"
          }, {
            title: "Internet de las Cosas",
            target: "_self",
            href: "https://www.mongodb.com/es/use-cases/internet-of-things"
          }, {
            title: "Móvil",
            target: "_self",
            href: "https://www.mongodb.com/es/use-cases/mobile"
          }, {
            title: "Pagos",
            target: "_self",
            href: "https://www.mongodb.com/es/use-cases/payments"
          }, {
            title: "Desarrollos Serverless",
            target: "_self",
            href: "https://www.mongodb.com/es/use-cases/serverless"
          }, {
            title: "Todos los casos de uso",
            target: "_self",
            href: "https://www.mongodb.com/es/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "Plataforma de datos para desarrolladores",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "Ver todo",
            target: "_self",
            href: "https://www.mongodb.com/es/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "Informes técnicos y presentaciones",
            description: "Seminarios web, informes técnicos, hojas de datos y mucho más"
          },
          button: {
            title: "Ver todo",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "Recursos",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "Documentación",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "Server",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "Controladores",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "Empezar con las guías",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "predeterminado",
        columns: [{
          header: {
            title: "Comunidad",
            hasDivider: true
          },
          subColumns: [[{
            title: "Centro de Desarrolladores",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "Eventos y seminarios web",
            target: "_self",
            href: "https://www.mongodb.com/es/events-webinars-overview"
          }, {
            title: "Foros",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "Campeones",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "Buscar un Grupo de Usuarios",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "Educación",
            hasDivider: true
          },
          subColumns: [[{
            title: "Universidad",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "Certificación",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "Academia",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "Cursos básicos de MongoDB",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "Examinar todos los cursos",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "Empresa",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Acerca de",
            hasDivider: true
          },
          subColumns: [[{
            title: "Quiénes somos",
            target: "_self",
            href: "https://www.mongodb.com/es/company"
          }, {
            title: "Clientes",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "Blog",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "Empleo",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "Sala de prensa",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "Liderazgo",
            target: "_self",
            href: "https://www.mongodb.com/es/leadership"
          }, {
            title: "Inversores",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "Servicios",
            hasDivider: true
          },
          subColumns: [[{
            title: "Consultoría",
            target: "_self",
            href: "https://www.mongodb.com/es/products/consulting"
          }, {
            title: "Formación",
            target: "_self",
            href: "https://www.mongodb.com/es/products/training"
          }, {
            title: "Soporte empresarial",
            target: "_self",
            href: "https://www.mongodb.com/es/support"
          }, {
            title: "Customer Success",
            target: "_self",
            href: "https://www.mongodb.com/es/customer-success"
          }]]
        }, {
          header: {
            title: "Colaboraciones",
            hasDivider: true
          },
          subColumns: [[{
            title: "Convertirse en partner",
            target: "_self",
            href: "https://www.mongodb.com/es/partners/partner-program"
          }, {
            title: "Buscar un partner",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB para nuevas empresas",
            target: "_self",
            href: "https://www.mongodb.com/es/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Precios",
    target: "_self",
    href: "https://www.mongodb.com/es/pricing"
  }],
  secondary: {
    "try": {
      title: "Prueba gratuita",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "Iniciar sesión",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "Enviar",
      options: [{
        value: "Información general",
        placeholder: "Buscar productos, informes técnicos y mucho más...",
        universalKey: "DOTCOM"
      }, {
        value: "Toda la documentación",
        placeholder: "Buscar en toda la documentación...",
        universalKey: "DOCS"
      }, {
        value: "Documentación de Realm",
        placeholder: "Buscar en la documentación de Realm...",
        universalKey: "REALM"
      }, {
        value: "Artículos y temas para desarrolladores",
        placeholder: "Buscar en artículos y temas...",
        universalKey: "DEVHUB"
      }, {
        value: "Foros de la comunidad",
        placeholder: "Buscar foros de la comunidad...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer$5 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "Acerca de",
    links: [{
      title: "Empleo",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "Inversores",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "Avisos legales",
      target: "_self",
      href: "https://www.mongodb.com/es/legal/legal-notices"
    }, {
      title: "Avisos de privacidad",
      target: "_self",
      href: "https://www.mongodb.com/es/legal/privacy-policy"
    }, {
      title: "Información sobre seguridad",
      target: "_self",
      href: "https://www.mongodb.com/es/security"
    }, {
      title: "Centro de confianza",
      target: "_self",
      href: "https://www.mongodb.com/es/cloud/trust"
    }, {
      title: "Mapa del sitio",
      target: "_self",
      href: "https://www.mongodb.com/es/html-sitemap"
    }]
  }, {
    title: "Soporte",
    links: [{
      title: "Contacto",
      target: "_self",
      href: "https://www.mongodb.com/es/contact"
    }, {
      title: "Portal de clientes",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Atlas Status",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "Asistencia de pago",
      target: "_self",
      href: "https://www.mongodb.com/es/support"
    }, {
      id: "manage-cookies",
      title: "Gestionar Cookies",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "Social",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var es = {
  nav: nav$5,
  footer: footer$5
};
var nav$4 = {
  primary: [{
    title: "제품",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/atlas",
            description: "개발자 데이터 플랫폼",
            hasDivider: true
          },
          subColumns: [[{
            title: "데이터베이스",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/atlas/database"
          }, {
            title: "검색",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/atlas/search"
          }, {
            title: "Data Lake (프리뷰 버전)",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/atlas/data-lake"
          }, {
            title: "차트",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/charts"
          }, {
            title: "디바이스 동기화",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/mongodb-enterprise-advanced",
            description: "엔터프라이즈 소프트웨어 및 지원",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/ops-manager"
          }, {
            title: "엔터프라이즈 Kubernetes 운영자",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "커뮤니티 에디션",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "수백만명이 사용 중인 무료 소프트웨어",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "클라우드 매니저",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/cloud/cloud-manager"
          }, {
            title: "커뮤니티 Kubernetes 운영자",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "도구",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/developer-tools",
            description: "보다 빠르게 구축 가능",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "Compass IDE",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/shell"
          }, {
            title: "VS Code Plugin",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/cloud/cli"
          }, {
            title: "데이터베이스 커넥터",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/connectors"
          }, {
            title: "클러스터간 동기화",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "솔루션",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "산업별",
            hasDivider: true
          },
          subColumns: [[{
            title: "금융 서비스",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries/financial-services"
          }, {
            title: "텔레콤",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries/telecommunications"
          }, {
            title: "헬스케어",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries/healthcare"
          }, {
            title: "리테일",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries/manufacturing"
          }, {
            title: "모든 산업",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/industries"
          }]]
        }, {
          header: {
            title: "사례별",
            hasDivider: true
          },
          subColumns: [[{
            title: "분석",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/use-cases/analytics"
          }, {
            title: "IoT(사물인터넷)",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/use-cases/internet-of-things"
          }, {
            title: "모바일",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/use-cases/mobile"
          }, {
            title: "결제(Payment)",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/use-cases/payments"
          }, {
            title: "서버리스 개발",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/use-cases/serverless"
          }, {
            title: "모든 사례",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "개발자 데이터 플랫폼",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "모두 보기",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "백서 및 프리젠테이션 자료",
            description: "웨비나, 백서, 데이터시트 및 기타"
          },
          button: {
            title: "모두 보기",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "리소스",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "문서",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "서버",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "드라이버",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "가이드 시작",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "커뮤니티",
            hasDivider: true
          },
          subColumns: [[{
            title: "개발자 센터",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "이벤트 및 웨비나",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/events-webinars-overview"
          }, {
            title: "포럼",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "MongoDB 옹호자",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "사용자 그룹 찾기",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "교육",
            hasDivider: true
          },
          subColumns: [[{
            title: "유니버시티",
            target: "_self",
            href: "https://learn.mongodb.com"
          }, {
            title: "인증",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "아카데미아",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "MongoDB 초급 코스",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "모든 코스 검색",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "회사",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "회사정보",
            hasDivider: true
          },
          subColumns: [[{
            title: "MongoDB 정보",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/company"
          }, {
            title: "고객 사례",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "블로그",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "인재채용",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "프레스룸",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "리더십",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/leadership"
          }, {
            title: "투자자",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "서비스",
            hasDivider: true
          },
          subColumns: [[{
            title: "컨설팅",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/consulting"
          }, {
            title: "교육",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/products/training"
          }, {
            title: "엔터프라이즈 지원",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/support"
          }, {
            title: "고객 성공 사례",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/customer-success"
          }]]
        }, {
          header: {
            title: "파트너십",
            hasDivider: true
          },
          subColumns: [[{
            title: "파트너 등록",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/partners/partner-program"
          }, {
            title: "파트너 찾기",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "스타트업용 MongoDB",
            target: "_self",
            href: "https://www.mongodb.com/ko-kr/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "가격",
    target: "_self",
    href: "https://www.mongodb.com/ko-kr/pricing"
  }],
  secondary: {
    "try": {
      title: "무료 체험판 다운로드",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "등록",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "제출",
      options: [{
        value: "일반 정보",
        placeholder: "제품, 백서 및 추가 검색 중...",
        universalKey: "DOTCOM"
      }, {
        value: "모든 문서",
        placeholder: "모든 문서 검색 중...",
        universalKey: "DOCS"
      }, {
        value: "Realm 문서",
        placeholder: "Realm 문서 검색 중...",
        universalKey: "REALM"
      }, {
        value: "개발자 기사 및 주제",
        placeholder: "기사 및 주제 검색 중...",
        universalKey: "DEVHUB"
      }, {
        value: "커뮤니티 포럼",
        placeholder: "커뮤니티 포럼 검색 중...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer$4 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "회사정보",
    links: [{
      title: "인재채용",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "투자자",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "법적고지",
      target: "_self",
      href: "https://www.mongodb.com/ko-kr/legal/legal-notices"
    }, {
      title: "개인정보보호",
      target: "_self",
      href: "https://www.mongodb.com/ko-kr/legal/privacy-policy"
    }, {
      title: "보안 정보",
      target: "_self",
      href: "https://www.mongodb.com/ko-kr/security"
    }, {
      title: "트러스트 센터",
      target: "_self",
      href: "https://www.mongodb.com/ko-kr/cloud/trust"
    }]
  }, {
    title: "지원",
    links: [{
      title: "문의처",
      target: "_self",
      href: "https://www.mongodb.com/ko-kr/contact"
    }, {
      title: "고객 포털",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Atlas 상태",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "유료 지원",
      target: "_self",
      href: "https://www.mongodb.com/ko-kr/products/enterprise-grade-support"
    }, {
      id: "manage-cookies",
      title: "쿠리 관리",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "SNS",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var koKr = {
  nav: nav$4,
  footer: footer$4
};
var nav$3 = {
  primary: [{
    title: "Prodotti",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/it-it/atlas",
            description: "Piattaforma di data per sviluppatori",
            hasDivider: true
          },
          subColumns: [[{
            title: "Database",
            target: "_self",
            href: "https://www.mongodb.com/it-it/atlas/database"
          }, {
            title: "Cerca",
            target: "_self",
            href: "https://www.mongodb.com/it-it/atlas/search"
          }, {
            title: "Data Lake (Anteprima)",
            target: "_self",
            href: "https://www.mongodb.com/it-it/atlas/data-lake"
          }, {
            title: "Charts",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/it-it/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/it-it/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/mongodb-enterprise-advanced",
            description: "Software aziendale e supporto",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/ops-manager"
          }, {
            title: "Enterprise Kubernetes Operator",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "Community Edition",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "Software gratuito utilizzato da milioni di utenti",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/it-it/cloud/cloud-manager"
          }, {
            title: "Community Kubernetes Operator",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "Strumenti",
            target: "_self",
            href: "https://www.mongodb.com/it-it/developer-tools",
            description: "Sviluppa applicazioni più velocemente",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "Compass IDE",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/shell"
          }, {
            title: "VS Code Plugin",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/it-it/cloud/cli"
          }, {
            title: "Connettori database",
            target: "_self",
            href: "https://www.mongodb.com/it-it/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Soluzioni",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Per settore",
            hasDivider: true
          },
          subColumns: [[{
            title: "Servizi finanziari",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries/financial-services"
          }, {
            title: "Telecomunicazioni",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries/telecommunications"
          }, {
            title: "Settore sanitario",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries/healthcare"
          }, {
            title: "Vendita al dettaglio",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries/manufacturing"
          }, {
            title: "Tutti i settori",
            target: "_self",
            href: "https://www.mongodb.com/it-it/industries"
          }]]
        }, {
          header: {
            title: "Per caso di utilizzo",
            hasDivider: true
          },
          subColumns: [[{
            title: "Analitica",
            target: "_self",
            href: "https://www.mongodb.com/it-it/use-cases/analytics"
          }, {
            title: "Internet of Things",
            target: "_self",
            href: "https://www.mongodb.com/it-it/use-cases/internet-of-things"
          }, {
            title: "Mobile",
            target: "_self",
            href: "https://www.mongodb.com/it-it/use-cases/mobile"
          }, {
            title: "Pagamenti",
            target: "_self",
            href: "https://www.mongodb.com/it-it/use-cases/payments"
          }, {
            title: "Serverless Development",
            target: "_self",
            href: "https://www.mongodb.com/it-it/use-cases/serverless"
          }, {
            title: "Tutti i casi di utilizzo",
            target: "_self",
            href: "https://www.mongodb.com/it-it/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "Piattaforma di data per sviluppatori",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "Visualizza tutto",
            target: "_self",
            href: "https://www.mongodb.com/it-it/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "White paper e presentazioni",
            description: "Webinar, white paper, schede dati e altro"
          },
          button: {
            title: "Visualizza tutto",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "Risorse",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "Documentazione",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "Server",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "Driver",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "Inizia con le guide",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "Community",
            hasDivider: true
          },
          subColumns: [[{
            title: "Developer Center",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "Eventi e webinar",
            target: "_self",
            href: "https://www.mongodb.com/it-it/events-webinars-overview"
          }, {
            title: "Forum",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "Champions",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "Trova uno User Group locale ",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "Formazione",
            hasDivider: true
          },
          subColumns: [[{
            title: "Università",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "Certificazione",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "Accademia",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "Corso di base di MongoDB",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "Scopri tutti i corsi",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "Azienda",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Informazioni riguardo MongoDB",
            hasDivider: true
          },
          subColumns: [[{
            title: "Chi siamo",
            target: "_self",
            href: "https://www.mongodb.com/it-it/company"
          }, {
            title: "Storie di successo dei clienti",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "Blog",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "Posizioni",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "Area stampa",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "Leadership",
            target: "_self",
            href: "https://www.mongodb.com/it-it/leadership"
          }, {
            title: "Investitori",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "Servizi",
            hasDivider: true
          },
          subColumns: [[{
            title: "Consulenza",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/consulting"
          }, {
            title: "Formazione",
            target: "_self",
            href: "https://www.mongodb.com/it-it/products/training"
          }, {
            title: "Customer Support",
            target: "_self",
            href: "https://www.mongodb.com/it-it/support"
          }, {
            title: "Successo dei Clienti",
            target: "_self",
            href: "https://www.mongodb.com/it-it/customer-success"
          }]]
        }, {
          header: {
            title: "Collaborazioni",
            hasDivider: true
          },
          subColumns: [[{
            title: "Diventa un partner",
            target: "_self",
            href: "https://www.mongodb.com/it-it/partners/partner-program"
          }, {
            title: "Trova un partner",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB per le startup",
            target: "_self",
            href: "https://www.mongodb.com/it-it/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Prezzi",
    target: "_self",
    href: "https://www.mongodb.com/it-it/pricing"
  }],
  secondary: {
    "try": {
      title: "Prova gratuita",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "Accedi",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "Invio",
      options: [{
        value: "Informazioni generali",
        placeholder: "Cerca in prodotti, whitepaper e altro...",
        universalKey: "DOTCOM"
      }, {
        value: "Tutta la documentazione",
        placeholder: "Cerca in tutta la documentazione...",
        universalKey: "DOCS"
      }, {
        value: "Documentazione Realm",
        placeholder: "Cerca nella documentazione Realm...",
        universalKey: "REALM"
      }, {
        value: "Articoli e argomenti per sviluppatori",
        placeholder: "Cerca in articoli e argomenti...",
        universalKey: "DEVHUB"
      }, {
        value: "Forum della community",
        placeholder: "Cerca nei forum della community...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer$3 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "Informazioni",
    links: [{
      title: "Posizioni",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "Investitori",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "Note legali",
      target: "_self",
      href: "https://www.mongodb.com/it-it/legal/legal-notices"
    }, {
      title: "Informativa sulla privacy",
      target: "_self",
      href: "https://www.mongodb.com/it-it/legal/privacy-policy"
    }, {
      title: "Informazioni sulla sicurezza",
      target: "_self",
      href: "https://www.mongodb.com/it-it/security"
    }, {
      title: "Centro protezione",
      target: "_self",
      href: "https://www.mongodb.com/it-it/cloud/trust"
    }]
  }, {
    title: "Supporto",
    links: [{
      title: "Contattaci",
      target: "_self",
      href: "https://www.mongodb.com/it-it/contact"
    }, {
      title: "Portale dei clienti",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Atlas Status",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "Supporto a pagamento",
      target: "_self",
      href: "https://www.mongodb.com/it-it/products/enterprise-grade-support"
    }, {
      id: "manage-cookies",
      title: "Gestisci Cookie",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "Social",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var itIt = {
  nav: nav$3,
  footer: footer$3
};
var nav$2 = {
  primary: [{
    title: "Produkte",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/de-de/atlas",
            description: "Datenplattform für Entwickler",
            hasDivider: true
          },
          subColumns: [[{
            title: "Datenbank",
            target: "_self",
            href: "https://www.mongodb.com/de-de/atlas/database"
          }, {
            title: "Suche",
            target: "_self",
            href: "https://www.mongodb.com/de-de/atlas/search"
          }, {
            title: "Data Lake (Vorschau)",
            target: "_self",
            href: "https://www.mongodb.com/de-de/atlas/data-lake"
          }, {
            title: "Charts",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/de-de/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/de-de/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/mongodb-enterprise-advanced",
            description: "Enterprise Software und Support",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/ops-manager"
          }, {
            title: "Enterprise Kubernetes Operator",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "Community Edition",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "Kostenlose Software, die von Millionen genutzt wird",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/de-de/cloud/cloud-manager"
          }, {
            title: "Community Kubernetes Operator",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "Tools",
            target: "_self",
            href: "https://www.mongodb.com/de-de/developer-tools",
            description: "Schneller entwickeln",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "Compass",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/shell"
          }, {
            title: "VS-Code-Plugin",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/de-de/cloud/cli"
          }, {
            title: "Datenbank-Konnektoren",
            target: "_self",
            href: "https://www.mongodb.com/de-de/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Lösungen",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Nach Industrie",
            hasDivider: true
          },
          subColumns: [[{
            title: "Finanzdienstleistungen",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries/financial-services"
          }, {
            title: "Telekommunikation",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries/telecommunications"
          }, {
            title: "Gesundheitswesen",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries/healthcare"
          }, {
            title: "Einzelhandel",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries/manufacturing"
          }, {
            title: "Alle Industrien",
            target: "_self",
            href: "https://www.mongodb.com/de-de/industries"
          }]]
        }, {
          header: {
            title: "Nach Use Case",
            hasDivider: true
          },
          subColumns: [[{
            title: "Analytik",
            target: "_self",
            href: "https://www.mongodb.com/de-de/use-cases/analytics"
          }, {
            title: "Internet of Things",
            target: "_self",
            href: "https://www.mongodb.com/de-de/use-cases/internet-of-things"
          }, {
            title: "Mobile",
            target: "_self",
            href: "https://www.mongodb.com/de-de/use-cases/mobile"
          }, {
            title: "Zahlung",
            target: "_self",
            href: "https://www.mongodb.com/de-de/use-cases/payments"
          }, {
            title: "Serverlose Entwicklung",
            target: "_self",
            href: "https://www.mongodb.com/de-de/use-cases/serverless"
          }, {
            title: "Alle Use Cases",
            target: "_self",
            href: "https://www.mongodb.com/de-de/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "Datenplattform für Entwickler",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "Alle anzeigen",
            target: "_self",
            href: "https://www.mongodb.com/de-de/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "Whitepapers und Präsentationen",
            description: "Webinare, Whitepapers, Datenblätter und mehr"
          },
          button: {
            title: "Alle anzeigen",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "Ressourcen",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "Dokumentation",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "Server",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "Treiber",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "Mit unseren Guides loslegen",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "Community",
            hasDivider: true
          },
          subColumns: [[{
            title: "Entwicklerzentrum",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "Veranstaltungen und Webinare",
            target: "_self",
            href: "https://www.mongodb.com/de-de/events-webinars-overview"
          }, {
            title: "Foren",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "Champions",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "Eine Benutzergruppe finden",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "Bildung",
            hasDivider: true
          },
          subColumns: [[{
            title: "University",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "Zertifizierung",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "Akademia",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "MongoDB Grundlagenkurs",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "Alle Kurse durchsuchen",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "Unternehmen",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Über uns",
            hasDivider: true
          },
          subColumns: [[{
            title: "Wer wir sind",
            target: "_self",
            href: "https://www.mongodb.com/de-de/company"
          }, {
            title: "Kundenberichte",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "Blog",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "Karriere",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "Pressroom",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "Unternehmensleitung",
            target: "_self",
            href: "https://www.mongodb.com/de-de/leadership"
          }, {
            title: "Investoren",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "Services",
            hasDivider: true
          },
          subColumns: [[{
            title: "Beratung",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/consulting"
          }, {
            title: "Training",
            target: "_self",
            href: "https://www.mongodb.com/de-de/products/training"
          }, {
            title: "Customer Support",
            target: "_self",
            href: "https://www.mongodb.com/de-de/support"
          }, {
            title: "Customer Success",
            target: "_self",
            href: "https://www.mongodb.com/de-de/customer-success"
          }]]
        }, {
          header: {
            title: "Partnerschaften",
            hasDivider: true
          },
          subColumns: [[{
            title: "Partner werden",
            target: "_self",
            href: "https://www.mongodb.com/de-de/partners/partner-program"
          }, {
            title: "Partner finden",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB für Startups",
            target: "_self",
            href: "https://www.mongodb.com/de-de/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Preise",
    target: "_self",
    href: "https://www.mongodb.com/de-de/pricing"
  }],
  secondary: {
    "try": {
      title: "Kostenlos testen",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "Anmelden",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "Absenden",
      options: [{
        value: "Allgemeine Informationen",
        placeholder: "Produkte, Whitepaper und mehr ansehen...",
        universalKey: "DOTCOM"
      }, {
        value: "Gesamte Dokumentation",
        placeholder: "Gesamte Dokumentation durchsuchen...",
        universalKey: "DOCS"
      }, {
        value: "Realm Dokumentation",
        placeholder: "Realm Dokumentation durchsuchen...",
        universalKey: "REALM"
      }, {
        value: "Artikel und Themen für Entwickler",
        placeholder: "Artikel und Themen durchsuchen...",
        universalKey: "DEVHUB"
      }, {
        value: "Community-Foren",
        placeholder: "Community-Foren durchsuchen...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer$2 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "Über uns",
    links: [{
      title: "Karriere",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "Investoren",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "Rechtliche Hinweise",
      target: "_self",
      href: "https://www.mongodb.com/de-de/legal/legal-notices"
    }, {
      title: "Datenschutz",
      target: "_self",
      href: "https://www.mongodb.com/de-de/legal/privacy-policy"
    }, {
      title: "Sicherheitsinformationen",
      target: "_self",
      href: "https://www.mongodb.com/de-de/security"
    }, {
      title: "Trust Center",
      target: "_self",
      href: "https://www.mongodb.com/de-de/cloud/trust"
    }, {
      title: "Sitemap",
      target: "_self",
      href: "https://www.mongodb.com/de-de/html-sitemap"
    }, {
      title: "Impressum",
      target: "_self",
      href: "https://www.mongodb.com/de-de/company#impressum"
    }]
  }, {
    title: "Support",
    links: [{
      title: "Kontakt",
      target: "_self",
      href: "https://www.mongodb.com/de-de/contact"
    }, {
      title: "Kunden-Portal",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Atlas Status",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "Bezahlter Support",
      target: "_self",
      href: "https://www.mongodb.com/de-de/products/enterprise-grade-support"
    }, {
      id: "manage-cookies",
      title: "Cookies verwalten",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "Social",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "YouTube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var deDe = {
  nav: nav$2,
  footer: footer$2
};
var nav$1 = {
  primary: [{
    title: "Produits",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/atlas",
            description: "Plateforme de données pour développeurs",
            hasDivider: true
          },
          subColumns: [[{
            title: "Base de données",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/atlas/database"
          }, {
            title: "Recherche",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/atlas/search"
          }, {
            title: "Data Lake (Prévisualisation)",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/atlas/data-lake"
          }, {
            title: "Charts",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/mongodb-enterprise-advanced",
            description: "Logiciel d'entreprise et support",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/ops-manager"
          }, {
            title: "Opérateur Kubernetes d'entreprise",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "Édition communauté",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "Logiciel gratuit utilisé par des millions de personnes",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/cloud/cloud-manager"
          }, {
            title: "Opérateur communautaire Kubernetes",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "Outils",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/developer-tools",
            description: "Créez plus rapidement",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "Compass IDE",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/shell"
          }, {
            title: "Plugin VS Code",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/cloud/cli"
          }, {
            title: "Connecteurs de base de données",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Solutions",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Par secteur d'activité",
            hasDivider: true
          },
          subColumns: [[{
            title: "Services Financiers",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries/financial-services"
          }, {
            title: "Télécommunications",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries/telecommunications"
          }, {
            title: "Santé",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries/healthcare"
          }, {
            title: "Retail",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries/retail"
          }, {
            title: "Public Sector",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries/manufacturing"
          }, {
            title: "Tous secteurs d'activité",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/industries"
          }]]
        }, {
          header: {
            title: "Par cas d'utilisation",
            hasDivider: true
          },
          subColumns: [[{
            title: "Analytique",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/use-cases/analytics"
          }, {
            title: "Internet des objets",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/use-cases/internet-of-things"
          }, {
            title: "Mobile",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/use-cases/mobile"
          }, {
            title: "Paiements",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/use-cases/payments"
          }, {
            title: "Développement sans serveur",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/use-cases/serverless"
          }, {
            title: "Tous les cas d'utilisation",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "Plateforme de données pour développeurs",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "Tout afficher",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "Livres blancs et présentations",
            description: "Webinaires, livres blancs, fiches techniques, etc."
          },
          button: {
            title: "Tout afficher",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "Ressources",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "Documentation",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "Serveur",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "Pilotes",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "Commencez par les guides",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "Communauté",
            hasDivider: true
          },
          subColumns: [[{
            title: "Centre des développeurs",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "Événements et webinaires",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/events-webinars-overview"
          }, {
            title: "Forums",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "Champions",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "Trouver un groupe d'utilisateurs",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "Éducation",
            hasDivider: true
          },
          subColumns: [[{
            title: "Université",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "Certification",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "Académie (Academia)",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "Formation MongoDB basic",
            target: "_self",
            href: "https://learn.mongodb.com/learn/learning-path/introduction-to-mongodb"
          }, {
            title: "Parcourir tous les cours",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "Entreprise",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "À propos",
            hasDivider: true
          },
          subColumns: [[{
            title: "Qui sommes-nous?",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/company"
          }, {
            title: "Témoignages clients",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "Blog",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "Carrières",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "Salle de presse",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "Direction",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/leadership"
          }, {
            title: "Investisseurs",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "Services",
            hasDivider: true
          },
          subColumns: [[{
            title: "Conseils",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/consulting"
          }, {
            title: "Formation",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/products/training"
          }, {
            title: "Soutien aux entreprises",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/support"
          }, {
            title: "Customer Success",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/customer-success"
          }]]
        }, {
          header: {
            title: "Partenariats",
            hasDivider: true
          },
          subColumns: [[{
            title: "Devenir partenaire",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/partners/partner-program"
          }, {
            title: "Trouver un partenaire",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB pour les start-ups",
            target: "_self",
            href: "https://www.mongodb.com/fr-fr/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "Tarifs",
    target: "_self",
    href: "https://www.mongodb.com/fr-fr/pricing"
  }],
  secondary: {
    "try": {
      title: "Essayez gratuitement",
      target: "_self",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "Connexion",
      target: "_self",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "Recherche",
      options: [{
        value: "Informations générales",
        placeholder: "Rechercher des produits, des livres blancs etc...",
        universalKey: "DOTCOM"
      }, {
        value: "Toute la documentation",
        placeholder: "Rechercher dans toute la documentation...",
        universalKey: "DOCS"
      }, {
        value: "Documentation de Realm",
        placeholder: "Recherchez la documentation de Realm...",
        universalKey: "REALM"
      }, {
        value: "Articles et sujets développeur",
        placeholder: "Rechercher dans les articles et sujets...",
        universalKey: "DEVHUB"
      }, {
        value: "Forums communautaires",
        placeholder: "Rechercher dans les forums communautaires...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer$1 = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "À propos",
    links: [{
      title: "Carrières",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "Investisseurs",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "Mentions Légales",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/legal/legal-notices"
    }, {
      title: "Avis de confidentialité",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/legal/privacy-policy"
    }, {
      title: "Information de sécurité",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/security"
    }, {
      title: "Centre de gestion de la confidentialité",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/cloud/trust"
    }, {
      title: "Plan du site",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/html-sitemap"
    }]
  }, {
    title: "Support",
    links: [{
      title: "Nous Contacter",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/contact"
    }, {
      title: "Portail client",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Statut d'Atlas",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "Assistance payante",
      target: "_self",
      href: "https://www.mongodb.com/fr-fr/products/enterprise-grade-support"
    }, {
      id: "manage-cookies",
      title: "Paramètres des cookies",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "Réseaux sociaux",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var frFr = {
  nav: nav$1,
  footer: footer$1
};
var nav = {
  primary: [{
    title: "产品",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "Atlas",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/atlas",
            description: "开发者数据平台",
            hasDivider: true
          },
          subColumns: [[{
            title: "数据库",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/atlas/database"
          }, {
            title: "搜索",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/atlas/search"
          }, {
            title: "Data Lake (预览版)",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/atlas/data-lake"
          }, {
            title: "Charts",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/charts"
          }, {
            title: "Device Sync",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/atlas/app-services/device-sync"
          }, {
            title: "APIs, Triggers, Functions",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/atlas/app-services"
          }]]
        }, {
          header: {
            title: "Enterprise Advanced",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/mongodb-enterprise-advanced",
            description: "企业版软件和支持",
            hasDivider: true
          },
          subColumns: [[{
            title: "Enterprise Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/enterprise"
          }, {
            title: "Ops Manager",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/ops-manager"
          }, {
            title: "企业 Kubernetes 运营商",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/kubernetes-operator/master/"
          }]]
        }, {
          header: {
            title: "社区版",
            arrow: true,
            target: "_self",
            href: "https://www.mongodb.com/try/download/community",
            description: "数百万人使用的免费软件",
            hasDivider: true
          },
          subColumns: [[{
            title: "Community Server",
            target: "_self",
            href: "https://www.mongodb.com/try/download/community"
          }, {
            title: "Cloud Manager",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/cloud/cloud-manager"
          }, {
            title: "社区 Kubernetes 运营商",
            target: "_self",
            href: "https://github.com/mongodb/mongodb-kubernetes-operator"
          }]]
        }]
      }, {
        background: "gray",
        columns: [{
          header: {
            title: "工具",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/developer-tools",
            description: "更快速构建",
            hasDivider: true,
            arrow: true
          },
          subColumns: [[{
            title: "Compass IDE",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/compass"
          }, {
            title: "Shell",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/shell"
          }, {
            title: "VS 代码插件",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/vs-code"
          }, {
            title: "Atlas CLI",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/cloud/cli"
          }, {
            title: "数据库连接器",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/connectors"
          }, {
            title: "Cluster-to-Cluster Sync",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/cluster-to-cluster-sync"
          }, {
            title: "Relational Migrator",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/relational-migrator"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "解决方案",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "按行业",
            hasDivider: true
          },
          subColumns: [[{
            title: "金融服务",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/industries/financial-services"
          }, {
            title: "电信",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/industries/telecommunications"
          }, {
            title: "医疗",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/industries/healthcare"
          }, {
            title: "零售",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/industries/retail"
          }, {
            title: "Gaming",
            target: "_self",
            href: "https://www.mongodb.com/industries/government"
          }, {
            title: "Manufacturing",
            target: "_self",
            href: "https://www.mongodb.com/industries/manufacturing"
          }, {
            title: "所有行业",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/industries"
          }]]
        }, {
          header: {
            title: "按用例",
            hasDivider: true
          },
          subColumns: [[{
            title: "分析",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/use-cases/analytics"
          }, {
            title: "物联网",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/use-cases/internet-of-things"
          }, {
            title: "移动",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/use-cases/mobile"
          }, {
            title: "交易",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/use-cases/payments"
          }, {
            title: "无服务器开发",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/use-cases/serverless"
          }, {
            title: "所有用例",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/use-cases"
          }]]
        }]
      }, {
        background: "gray",
        ctas: [{
          header: {
            title: "开发者数据平台",
            description: "Innovate fast at scale with a unified developer experience"
          },
          button: {
            title: "查看全部",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/developer-data-platform",
            variant: "primary"
          },
          hasDivider: true
        }, {
          header: {
            title: "白皮书和讲座",
            description: "网络研讨会、白皮书、数据表等更多内容"
          },
          button: {
            title: "查看全部",
            target: "_self",
            href: "https://www.mongodb.com/resources",
            variant: "primary"
          }
        }],
        columns: []
      }]
    },
    highlightUrls: null
  }, {
    title: "资源中心",
    dropdown: {
      sections: [{
        background: "gray",
        columns: [{
          header: {
            title: "文档",
            arrow: true,
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/",
            hasDivider: true
          },
          subColumns: [[{
            title: "Atlas",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/atlas/"
          }, {
            title: "服务器",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/manual/"
          }, {
            title: "驱动程序",
            target: "_self",
            href: "https://www.mongodb.com/docs/drivers/"
          }], [{
            title: "入门指南",
            target: "_self",
            standardizeDocsUrl: true,
            href: "https://www.mongodb.com/docs/guides/"
          }]]
        }]
      }, {
        background: "default",
        columns: [{
          header: {
            title: "社区",
            hasDivider: true
          },
          subColumns: [[{
            title: "开发者中心",
            target: "_self",
            href: "https://www.mongodb.com/developer/"
          }, {
            title: "活动与网络研讨会",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/events-webinars-overview"
          }, {
            title: "论坛",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/"
          }, {
            title: "MongoDB 拥护者",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/champions/"
          }, {
            title: "查找用户组",
            target: "_self",
            href: "https://www.mongodb.com/community/forums/c/user-groups/11"
          }]]
        }, {
          header: {
            title: "学习中心",
            hasDivider: true
          },
          subColumns: [[{
            title: "University",
            target: "_self",
            href: "https://learn.mongodb.com/"
          }, {
            title: "认证",
            target: "_self",
            href: "https://learn.mongodb.com/pages/certification-program"
          }, {
            title: "学习中心",
            target: "_self",
            href: "https://www.mongodb.com/academia"
          }, {
            title: "MongoDB 基础课程",
            target: "_self",
            href: "https://learn.mongodb.com/courses/M310/about"
          }, {
            title: "浏览全部课程",
            target: "_self",
            href: "https://learn.mongodb.com/catalog"
          }]]
        }]
      }]
    },
    highlightUrls: ["mongodb.com/developer", "mongodb.com/docs", "mongodb.com/community/forums", "university.mongodb.com", "docs.mongodb.com", "docs.atlas.mongodb.com", "developer-hub-staging", "docs-atlas-staging", "docs-mongodbcom-staging", "education-staging"]
  }, {
    title: "公司",
    dropdown: {
      sections: [{
        background: "default",
        columns: [{
          header: {
            title: "关于MongoDB",
            hasDivider: true
          },
          subColumns: [[{
            title: "关于MongoDB",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/company"
          }, {
            title: "成功案例",
            target: "_self",
            href: "https://www.mongodb.com/who-uses-mongodb"
          }, {
            title: "博客",
            target: "_self",
            href: "https://www.mongodb.com/blog"
          }, {
            title: "招贤纳士",
            target: "_self",
            href: "https://www.mongodb.com/careers"
          }, {
            title: "新闻中心",
            target: "_self",
            href: "https://www.mongodb.com/pressroom"
          }, {
            title: "领导层",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/leadership"
          }, {
            title: "投资者关系",
            target: "_self",
            href: "https://investors.mongodb.com/corporate-profile/default.aspx"
          }]]
        }, {
          header: {
            title: "服务",
            hasDivider: true
          },
          subColumns: [[{
            title: "咨询",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/consulting"
          }, {
            title: "培训",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/products/training"
          }, {
            title: "企业支持",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/support"
          }, {
            title: "客户成功案例",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/customer-success"
          }]]
        }, {
          header: {
            title: "合作伙伴",
            hasDivider: true
          },
          subColumns: [[{
            title: "成为合作伙伴",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/partners/partner-program"
          }, {
            title: "寻找合作伙伴",
            target: "_self",
            href: "https://www.mongodb.com/partners/list"
          }, {
            title: "MongoDB 助力初创公司",
            target: "_self",
            href: "https://www.mongodb.com/zh-cn/startups"
          }]]
        }]
      }]
    },
    highlightUrls: null
  }, {
    title: "定价",
    target: "_self",
    href: "https://www.mongodb.com/zh-cn/pricing"
  }],
  secondary: {
    "try": {
      title: "免费试用",
      href: "https://www.mongodb.com/cloud/atlas/register"
    },
    login: {
      title: "登录",
      href: "https://account.mongodb.com/account/login"
    },
    search: {
      submit: "提交",
      options: [{
        value: "基本信息",
        placeholder: "搜索产品、白皮书等...",
        universalKey: "DOTCOM"
      }, {
        value: "所有文档",
        placeholder: "搜索所有文档...",
        universalKey: "DOCS"
      }, {
        value: "Realm 文档",
        placeholder: "搜索 Realm 文档...",
        universalKey: "REALM"
      }, {
        value: "开发者文章和话题",
        placeholder: "搜索文章和话题...",
        universalKey: "DEVHUB"
      }, {
        value: "社区论坛",
        placeholder: "搜索社区论坛...",
        universalKey: "COMMUNITY"
      }]
    }
  }
};
var footer = {
  copyright: "© 2023 MongoDB, Inc.",
  sections: [{
    title: "关于MongoDB",
    links: [{
      title: "招贤纳士",
      target: "_self",
      href: "https://www.mongodb.com/careers"
    }, {
      title: "投资者关系",
      target: "_self",
      href: "https://investors.mongodb.com"
    }, {
      title: "法律声明",
      target: "_self",
      href: "https://www.mongodb.com/zh-cn/legal/legal-notices"
    }, {
      title: "隐私条款",
      target: "_self",
      href: "https://www.mongodb.com/zh-cn/legal/privacy-policy"
    }, {
      title: "安全信息",
      target: "_self",
      href: "https://www.mongodb.com/zh-cn/security"
    }, {
      title: "信任中心",
      target: "_self",
      href: "https://www.mongodb.com/zh-cn/cloud/trust"
    }]
  }, {
    title: "支持",
    links: [{
      title: "联系我们",
      target: "_self",
      href: "https://www.mongodb.com/zh-cn/contact"
    }, {
      title: "客户门户",
      target: "_self",
      href: "https://support.mongodb.com/welcome"
    }, {
      title: "Atlas 状态",
      target: "_self",
      href: "https://status.cloud.mongodb.com/"
    }, {
      title: "付费支持",
      target: "_self",
      href: "https://www.mongodb.com/zh-cn/products/enterprise-grade-support"
    }, {
      id: "manage-cookies",
      title: "管理 Cookie",
      target: "_self",
      href: "#"
    }]
  }, {
    title: "社交媒体",
    links: [{
      title: "Github",
      target: "_self",
      href: "https://github.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wrvghw9q75ytq1-github.svg?auto=format%252Ccompress"
    }, {
      title: "Stack Overflow",
      target: "_self",
      href: "https://stackoverflow.com/tags/mongodb/info",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsfh9d9z2m4jvx-stackoverflow.svg?auto=format%252Ccompress"
    }, {
      title: "LinkedIn",
      target: "_self",
      href: "https://www.linkedin.com/company/mongodbinc/",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsmr3g1ckzd0hs-linkedin.svg?auto=format%252Ccompress"
    }, {
      title: "Youtube",
      target: "_self",
      href: "https://youtube.com/user/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wsxwxsvrivp4q4-youtube.svg?auto=format%252Ccompress"
    }, {
      title: "Twitter",
      target: "_self",
      href: "https://twitter.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wt4s3sy4hlc22k-twitter.svg?auto=format%252Ccompress"
    }, {
      title: "Twitch",
      target: "_self",
      href: "https://twitch.tv/mongodb/videos",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtbzfgc05d27pb-twitch.svg?auto=format%252Ccompress"
    }, {
      title: "Facebook",
      target: "_self",
      href: "https://facebook.com/mongodb",
      icon: "https://webimages.mongodb.com/_com_assets/cms/kr6wtks9piclp67yr-facebook.svg?auto=format%252Ccompress"
    }]
  }]
};
var zhCn = {
  nav: nav,
  footer: footer
};
/**
 * Temporarily convert docs.mongodb.com urls (and other docs-related subdomains)
 * to a dotcom url format. The hope is to change all hardcoded docs.mongodb.com
 * links to become www.mongodb.com/docs links once QA is complete.
 * @param {string} url The original URL.
 * @param {string | undefined} dotcomBaseUrl The base URL to be used in place of docs.mongodb.com.
 */

var standardizeDocsUrl = function standardizeDocsUrl(url, dotcomBaseUrl) {
  if (!dotcomBaseUrl) {
    return url;
  }

  var decomposedUrl = url.split(".");
  var subdomainProduct = decomposedUrl[1] !== "mongodb" ? decomposedUrl[1] : null;

  if (!decomposedUrl[0].includes("docs")) {
    return url;
  }

  if (subdomainProduct) {
    dotcomBaseUrl = "".concat(dotcomBaseUrl, "/").concat(subdomainProduct);
  }

  var pathname = url.split(".mongodb.com")[1];
  pathname = pathname.split("/").slice(1).join("/");
  return pathname.length >= 1 ? "".concat(dotcomBaseUrl, "/").concat(pathname) : "".concat(dotcomBaseUrl, "/");
};

var handleDocUrls = function handleDocUrls(data, docsBaseUrl) {
  data.nav.primary.forEach(function (value) {
    if (value.dropdown) {
      value.dropdown.sections.forEach(function (section) {
        if (section.columns) {
          section.columns.forEach(function (column) {
            if (column.header && column.header.standardizeDocsUrl) {
              column.header.href = standardizeDocsUrl(column.header.href, docsBaseUrl);
            }

            if (column.subColumns) {
              column.subColumns.forEach(function (subColumnArr) {
                if (subColumnArr) {
                  subColumnArr.forEach(function (subColumn) {
                    if (subColumn && subColumn.standardizeDocsUrl) {
                      subColumn.href = standardizeDocsUrl(subColumn.href, docsBaseUrl);
                    }
                  });
                }
              });
            }
          });
        }

        if (section.ctas) {
          section.ctas.forEach(function (cta) {
            if (cta.header && cta.header.standardizeDocsUrl) {
              cta.header.href = standardizeDocsUrl(cta.header.href, docsBaseUrl);
            }

            if (cta.button && cta.button.standardizeDocsUrl) {
              cta.button.href = standardizeDocsUrl(cta.button.href);
            }
          });
        }
      });
    }
  });
  data.footer.sections.forEach(function (value) {
    value.links.forEach(function (link) {
      if (link.standardizeDocsUrl) {
        link.href = standardizeDocsUrl(link.href, docsBaseUrl);
      }
    });
  });
  return data;
};

var getData = function getData(docsBaseUrl) {
  return {
    "en-us": handleDocUrls(enUs, docsBaseUrl),
    "pt-br": handleDocUrls(ptBr, docsBaseUrl),
    es: handleDocUrls(es, docsBaseUrl),
    "ko-kr": handleDocUrls(koKr, docsBaseUrl),
    "it-it": handleDocUrls(itIt, docsBaseUrl),
    "de-de": handleDocUrls(deDe, docsBaseUrl),
    "fr-fr": handleDocUrls(frFr, docsBaseUrl),
    "zh-cn": handleDocUrls(zhCn, docsBaseUrl)
  };
};

var properties = ["DOTCOM", "REALM", "DOCS", "DEVHUB", "COMMUNITY"];

function isProperty(val) {
  return properties.includes(val);
}

var getContent = function getContent(docsBaseUrl) {
  return getData(docsBaseUrl);
};

var testData = getData();
/**
 *
 * @param data i18n data from json files
 * @returns a map where the keys are the value and the values are the universal keys for each
 * nav dropdown option
 *
 * e.g. "All Documentation" -> "DOCS"
 * This is used to map the selectedProperty in the NavSearch component.
 */

var getValueToPropertyMap = function getValueToPropertyMap(data) {
  var map = new Map();
  Object.values(data).forEach(function (_ref) {
    var nav = _ref.nav;
    var options = nav.secondary.search.options;
    options.forEach(function (_ref2) {
      var value = _ref2.value,
          universalKey = _ref2.universalKey;

      // theoretically, universalKey should be a part of the Property type literal,
      // but is of type string here
      // using a type guard to make typescript happy
      if (isProperty(universalKey)) {
        map.set(value, universalKey);
      }
    });
  });
  return map;
};

var valueToPropertyOptionsMap = getValueToPropertyMap(testData);

var getOptionUniversalKey = function getOptionUniversalKey(val) {
  return valueToPropertyOptionsMap.get(val);
};

var ESelectVariants;

(function (ESelectVariants) {
  ESelectVariants["DEFAULT"] = "default";
  ESelectVariants["MULTISELECT"] = "multi-select";
})(ESelectVariants || (ESelectVariants = {}));

var getIconColor = function getIconColor(inverse, disabled) {
  if (inverse) {
    return disabled ? "icon.system.inverseNeutral" : "icon.system.inverse";
  }

  return disabled ? "icon.system.defaultNeutral" : "icon.system.default";
};

var Icon = function Icon(_ref3) {
  var disabled = _ref3.disabled,
      inverse = _ref3.inverse,
      open = _ref3.open,
      theme$1 = _ref3.theme;
  var selectedTheme = theme$1 === "legacy" ? theme : defaultTheme;
  return jsx("div", Object.assign({
    sx: {
      padding: "0 ".concat(selectedTheme.space.inc30)
    }
  }, {
    children: jsx("svg", Object.assign({
      "data-testid": "icon",
      width: "16",
      height: "9",
      viewBox: "0 0 16 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      sx: {
        transform: open ? "rotateZ(90deg)" : "rotateZ(0.5deg)",
        transition: "transform .15s ease-in-out",
        zIndex: 0
      }
    }, {
      children: jsx("path", {
        d: "M1.06689 0.799988L8.00023 7.73332L14.9336 0.799988",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        sx: {
          stroke: getIconColor(inverse, disabled)
        }
      }, void 0)
    }), void 0)
  }), void 0);
};

var getLabelColor = function getLabelColor(open, invalid, inverse, disabled) {
  if (inverse) {
    if (open || disabled) {
      return "input.inverse.textSecondary";
    }

    return invalid ? "input.inverse.textError" : "input.inverse.text";
  }

  return disabled ? "text.neutral" : "input.default.text";
};

var getBackgroundColor = function getBackgroundColor(inverse, disabled) {
  if (inverse) {
    return disabled ? "background.selectedInverseLighter" : "background.containerInverse";
  }

  return disabled ? "background.container" : "background.body";
};

var SelectButton = function SelectButton(_ref4) {
  var props = Object.assign({}, _ref4);
  var id = props.id,
      open = props.open,
      variant = props.variant,
      hoverValue = props.hoverValue,
      value = props.value,
      multiSelectValues = props.multiSelectValues,
      disabled = props.disabled,
      inverse = props.inverse,
      invalid = props.invalid,
      border = props.border,
      width = props.width,
      children = props.children,
      theme$1 = props.theme;
  var selected;
  var selectedTheme = theme;

  if (variant === ESelectVariants.MULTISELECT) {
    selected = multiSelectValues;
  } else {
    selected = value || hoverValue;
  }

  return jsx(ThemeProvider, Object.assign({
    theme: selectedTheme
  }, {
    children: jsxs("button", Object.assign({
      id: id,
      role: "label",
      type: "button",
      sx: {
        position: "relative",
        display: "flex",
        justifyContent: open || value || multiSelectValues.length > 0 ? "space-between" : "flex-end",
        alignItems: "center",
        width: width || "280px",
        height: "48px",
        border: border === "none" ? "none" : "1px solid ".concat(invalid ? selectedTheme.colors.input.default.borderError : selectedTheme.colors.input.default.border),
        borderRadius: "input",
        boxSizing: "border-box",
        cursor: disabled ? "not-allowed" : "pointer",
        fontWeight: "300",
        bg: border === "none" ? "transparent" : getBackgroundColor(inverse, disabled),
        paddingLeft: "0"
      }
    }, {
      children: [children && jsx("div", Object.assign({
        sx: {
          display: "flex",
          pointerEvents: open ? null : "none",
          cursor: disabled ? "not-allowed" : "default",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          position: "absolute",
          left: "0",
          willChange: "transform, color, font-size",
          maxWidth: "calc(100% - ".concat(open || value || multiSelectValues.length > 0 ? selectedTheme.space.inc40 : selectedTheme.space.inc50, ")"),
          transform: "translateY(".concat(open || value || multiSelectValues.length > 0 ? "-".concat(selectedTheme.space.inc40) : "0px", ") translateX(").concat(open || value || multiSelectValues.length > 0 ? selectedTheme.space.base : selectedTheme.space.inc30, ")"),
          transition: "transform 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, color 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, font-size 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms",
          padding: "0 ".concat(selectedTheme.space.base),
          lineHeight: "inc00",
          fontFamily: selectedTheme.fonts.body,
          fontSize: open || value || multiSelectValues.length > 0 ? "inc00" : "inc20",
          color: getLabelColor(open, invalid, inverse, disabled),
          bg: getBackgroundColor(inverse, disabled)
        }
      }, {
        children: children
      }), void 0), hoverValue && open && !multiSelectValues.length && jsx("span", Object.assign({
        "data-testid": "hover-value",
        sx: {
          fontFamily: selectedTheme.fonts.body,
          fontSize: "inc20",
          lineHeight: "inc00",
          color: inverse ? "text.inverse" : "text.default",
          paddingLeft: "inc30",
          width: width || "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "left"
        }
      }, {
        children: hoverValue
      }), void 0), value && !open && jsx("span", Object.assign({
        "data-testid": "selected-value",
        sx: {
          fontFamily: selectedTheme.fonts.body,
          fontSize: "inc20",
          lineHeight: "inc00",
          color: inverse ? "text.inverse" : "text.default",
          paddingLeft: "inc30",
          width: width || "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "left"
        }
      }, {
        children: selected
      }), void 0), multiSelectValues.length !== 0 && jsx("span", Object.assign({
        "data-testid": "multi-select-values",
        sx: {
          fontFamily: selectedTheme.fonts.body,
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          fontSize: "inc20",
          lineHeight: "inc00",
          color: inverse ? "text.inverse" : "text.default",
          paddingLeft: "inc30"
        }
      }, {
        children: "(".concat(multiSelectValues.length, ") ").concat(multiSelectValues.join(", "))
      }), void 0), jsx(Icon, {
        disabled: disabled,
        open: open,
        inverse: inverse,
        theme: theme$1
      }, void 0)]
    }), void 0)
  }), void 0);
};

var MultiSelectOption = function MultiSelectOption(_ref5) {
  var option = _ref5.option,
      inverse = _ref5.inverse,
      values = _ref5.values,
      _ref5$theme = _ref5.theme,
      theme$1 = _ref5$theme === void 0 ? "default" : _ref5$theme,
      hover = _ref5.hover,
      multiSelectItems = _ref5.multiSelectItems,
      multiSelectToggle = _ref5.multiSelectToggle;
  var selectedTheme = theme;

  var _useState = useState(values.some(function (value) {
    return value === option;
  })),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var toggleCheckboxStyles = function toggleCheckboxStyles() {
    setSelected(!selected);
  };

  return jsx(ThemeProvider, Object.assign({
    theme: selectedTheme
  }, {
    children: jsxs("li", Object.assign({
      role: "option",
      tabIndex: 0,
      sx: {
        position: "relative",
        padding: selectedTheme.space.base,
        "&:not(:last-child)": {
          marginBottom: selectedTheme.space.base
        }
      },
      onMouseEnter: function onMouseEnter() {
        return hover(option);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          toggleCheckboxStyles();
          multiSelectToggle(option);
        }
      }
    }, {
      children: [jsx("input", {
        type: "checkbox",
        tabIndex: -1,
        id: option,
        name: option,
        sx: {
          position: "absolute",
          opacity: 0,
          "& ~ label > span": selected && {
            border: "1px solid ".concat(selectedTheme.colors.green50)
          },
          "& ~ label > span::after": selected && {
            content: '""'
          }
        }
      }, void 0), jsxs("label", Object.assign({
        htmlFor: option,
        tabIndex: -1,
        sx: {
          cursor: "pointer",
          display: "flex",
          alignItems: "center"
        },
        onClick: function onClick() {
          toggleCheckboxStyles();
          multiSelectToggle(option);
          multiSelectItems(values);
        }
      }, {
        children: [jsx("span", {
          sx: {
            cursor: "pointer",
            position: "relative",
            display: "inline-block",
            width: selectedTheme.space.inc40,
            height: selectedTheme.space.inc40,
            marginRight: selectedTheme.space.base,
            border: "1px solid ".concat(selectedTheme.colors.border.default),
            borderRadius: "input",
            overflow: "hidden",
            "&::before": {
              content: '""',
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bg: inverse ? "background.containerInverse" : "background.body",
              cursor: "pointer",
              position: "absolute",
              left: 0,
              top: 0
            },
            "&::after": {
              width: "100%",
              height: "100%",
              backgroundColor: "background.selected",
              backgroundImage: 'url("https://webimages.mongodb.com/_com_assets/cms/kq9tpkyancd805sjx-Path.svg?auto=format%252Ccompress")',
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              position: "absolute",
              top: 0,
              left: 0
            }
          }
        }, void 0), option]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var getInverseHoverStyles = function getInverseHoverStyles(inverse) {
  if (inverse) {
    return {
      bg: "background.selectedInverseLighter",
      color: "green40"
    };
  }

  return {
    bg: "green10",
    color: "text.selected"
  };
};

var Option = function Option(_ref6) {
  var option = _ref6.option,
      inverse = _ref6.inverse,
      theme$1 = _ref6.theme,
      hover = _ref6.hover,
      selected = _ref6.selected;
  var selectedTheme = theme$1 === "legacy" ? theme : defaultTheme;

  var getValue = function getValue(event) {
    var el = event.target;
    return el.innerText;
  };

  return jsx(ThemeProvider, Object.assign({
    theme: selectedTheme
  }, {
    children: jsx("li", Object.assign({
      role: "option",
      tabIndex: 0,
      sx: {
        cursor: "pointer",
        padding: selectedTheme.space.base,
        "&:not(:last-child)": {
          marginBottom: selectedTheme.space.base
        },
        "&:hover": _objectSpread({
          borderRadius: "inc10"
        }, getInverseHoverStyles(inverse))
      },
      onMouseEnter: function onMouseEnter() {
        return hover(option);
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        var value = getValue(e);
        selected(value);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === "Enter") {
          var value = getValue(e);
          selected(value);
        }
      }
    }, {
      children: option
    }), void 0)
  }), void 0);
};

var pxToInt = function pxToInt(px) {
  return Number(px.split("px")[0]);
};

var Dropdown = function Dropdown(_ref7) {
  var id = _ref7.id,
      options = _ref7.options,
      open = _ref7.open,
      variant = _ref7.variant,
      inverse = _ref7.inverse,
      width = _ref7.width,
      menuPlacement = _ref7.menuPlacement,
      wrapperHeight = _ref7.wrapperHeight,
      wrapperOffsetTop = _ref7.wrapperOffsetTop,
      theme$1 = _ref7.theme,
      onHover = _ref7.onHover,
      onSelect = _ref7.onSelect,
      onMultiSelect = _ref7.onMultiSelect;
  var selectedTheme = theme;

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedValues = _useState4[0],
      setSelectedValues = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      placement = _useState6[0],
      setPlacement = _useState6[1];

  var dropdownRef = useRef(null);

  var toggleMultiSelectValues = function toggleMultiSelectValues(value) {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter(function (option) {
        return option !== value;
      }));
    } else {
      setSelectedValues([].concat(_toConsumableArray(selectedValues), [value]));
    }
  };

  useEffect(function () {
    onMultiSelect(selectedValues);
  }, [selectedValues]);
  useEffect(function () {
    if (menuPlacement === "auto") {
      if (open && dropdownRef && dropdownRef.current && wrapperOffsetTop && wrapperHeight) {
        var spaceAfterSelect = document.body.offsetHeight - wrapperOffsetTop - wrapperHeight;

        if (spaceAfterSelect < dropdownRef.current.offsetHeight) {
          setPlacement("top");
        } else {
          setPlacement("bottom");
        }
      } else setPlacement(undefined);
    } else setPlacement(menuPlacement);
  }, [open]);
  return jsx(ThemeProvider, Object.assign({
    theme: selectedTheme
  }, {
    children: jsx("div", Object.assign({
      ref: dropdownRef,
      sx: {
        visibility: placement ? "visible" : "hidden",
        position: "absolute",
        zIndex: 1000,
        display: open ? "block" : "none",
        width: "100%",
        minWidth: width || "280px",
        marginTop: placement === "bottom" && "inc20",
        bottom: placement === "top" && wrapperHeight && wrapperHeight + pxToInt(selectedTheme.sizes.inc10),
        padding: "inc30",
        lineHeight: "inc00",
        fontSize: "inc20",
        color: inverse ? "text.inverse" : "text.default",
        fontFamily: selectedTheme.fonts.body,
        bg: inverse ? "background.containerInverse" : "background.body",
        border: "1px solid ".concat(selectedTheme.colors.input.default.border),
        borderRadius: "inc30",
        boxSizing: "border-box",
        boxShadow: "0px 3px 9px rgba(0, 0, 0, 0.15)"
      }
    }, {
      children: jsx("ul", Object.assign({
        "data-testid": "options",
        role: "listbox",
        "aria-labelledby": id,
        sx: {
          listStyleType: "none",
          margin: 0,
          padding: 0
        }
      }, {
        children: options.map(function (option, index) {
          return variant === ESelectVariants.DEFAULT ? jsx(Option, {
            option: option,
            inverse: inverse,
            theme: theme$1,
            hover: onHover,
            selected: onSelect
          }, index) : jsx(MultiSelectOption, {
            option: option,
            inverse: inverse,
            values: selectedValues,
            hover: onHover,
            theme: theme$1,
            multiSelectItems: onMultiSelect,
            multiSelectToggle: toggleMultiSelectValues
          }, index);
        })
      }), void 0)
    }), void 0)
  }), void 0);
};

var getColor$3 = function getColor$3(inverse, invalid) {
  if (inverse) {
    return invalid ? "text.errorInverse" : "text.inverseSecondary";
  }

  return invalid ? "text.error" : "text.secondary";
};

var Helper$1 = function Helper$1(_ref8) {
  var text = _ref8.text,
      open = _ref8.open,
      invalid = _ref8.invalid,
      inverse = _ref8.inverse,
      theme$1 = _ref8.theme;
  var selectedTheme = theme$1 === "legacy" ? theme : defaultTheme;
  return jsx(ThemeProvider, Object.assign({
    theme: selectedTheme
  }, {
    children: jsx("span", Object.assign({
      sx: {
        visibility: open ? "hidden" : "visible",
        color: getColor$3(inverse, invalid),
        textTransform: "capitalize",
        fontFamily: selectedTheme.fonts.body,
        display: "block",
        marginTop: "inc20",
        fontSize: "inc10",
        lineHeight: "inc20"
      }
    }, {
      children: text
    }), void 0)
  }), void 0);
};

var Select = function Select(_ref9) {
  var id = _ref9.id,
      name = _ref9.name,
      options = _ref9.options,
      className = _ref9.className,
      _ref9$theme = _ref9.theme,
      theme$1 = _ref9$theme === void 0 ? "default" : _ref9$theme,
      _ref9$disabled = _ref9.disabled,
      disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
      helper = _ref9.helper,
      _ref9$menuPlacement = _ref9.menuPlacement,
      menuPlacement = _ref9$menuPlacement === void 0 ? "bottom" : _ref9$menuPlacement,
      _ref9$inverse = _ref9.inverse,
      inverse = _ref9$inverse === void 0 ? false : _ref9$inverse,
      _ref9$invalid = _ref9.invalid,
      invalid = _ref9$invalid === void 0 ? false : _ref9$invalid,
      _ref9$border = _ref9.border,
      border = _ref9$border === void 0 ? "default" : _ref9$border,
      _ref9$value = _ref9.value,
      value = _ref9$value === void 0 ? undefined : _ref9$value,
      width = _ref9.width,
      _onSelect = _ref9.onSelect,
      onOpen = _ref9.onOpen,
      _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? ESelectVariants.DEFAULT : _ref9$variant;

  var _a, _b;

  var idValue = id || (name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/\s/g, ""));

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isDropdownOpen = _useState8[0],
      setIsDropdownOpen = _useState8[1];

  var _useState9 = useState(options[0]),
      _useState10 = _slicedToArray(_useState9, 2),
      hoverValue = _useState10[0],
      setHoverValue = _useState10[1];

  var _useState11 = useState(value),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedValue = _useState12[0],
      setSelectedValue = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      multiSelectValues = _useState14[0],
      setMultiSelectValues = _useState14[1];

  var wrapperRef = useRef(null);
  var wrapperHeight = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
  var wrapperOffsetTop = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop;
  return jsx(ThemeProvider, Object.assign({
    theme: theme$1 === "legacy" ? theme : defaultTheme
  }, {
    children: jsxs("div", Object.assign({
      ref: wrapperRef,
      className: className,
      sx: {
        width: width || "280px",
        display: "inline-block",
        position: "relative"
      },
      onClick: function onClick() {
        if (!disabled) {
          if (!isDropdownOpen && onOpen) onOpen();
          setIsDropdownOpen(!isDropdownOpen);
        }
      }
    }, {
      children: [jsx(SelectButton, Object.assign({
        id: idValue,
        open: isDropdownOpen,
        variant: variant,
        hoverValue: hoverValue,
        value: selectedValue,
        multiSelectValues: multiSelectValues,
        border: border,
        disabled: disabled,
        width: width,
        inverse: inverse,
        invalid: invalid,
        theme: theme$1
      }, {
        children: name
      }), void 0), jsx(Dropdown, {
        id: idValue,
        options: options,
        menuPlacement: menuPlacement,
        wrapperHeight: wrapperHeight,
        wrapperOffsetTop: wrapperOffsetTop,
        open: isDropdownOpen,
        width: width,
        variant: variant,
        inverse: inverse,
        theme: theme$1,
        onHover: setHoverValue,
        onSelect: function onSelect(value) {
          setSelectedValue(value);
          setIsDropdownOpen(!isDropdownOpen);

          if (_onSelect) {
            _onSelect(value);
          }
        },
        onMultiSelect: setMultiSelectValues
      }, void 0), helper && jsx(Helper$1, {
        text: helper,
        open: isDropdownOpen,
        invalid: invalid,
        inverse: inverse,
        theme: theme$1
      }, void 0)]
    }), void 0)
  }), void 0);
};

var getColor$2 = function getColor$2(invalid, disabled, inverse) {
  if (inverse) {
    if (invalid) {
      return "input.inverse.textError";
    }

    return disabled ? "input.inverse.textSecondary" : "input.inverse.text";
  }

  if (invalid) {
    return "input.default.textError";
  }

  return disabled ? "text.neutral" : "input.default.text";
};

var getVariantStyles$1 = function getVariantStyles$1(_ref10) {
  var _ref10$invalid = _ref10.invalid,
      invalid = _ref10$invalid === void 0 ? false : _ref10$invalid,
      _ref10$disabled = _ref10.disabled,
      disabled = _ref10$disabled === void 0 ? false : _ref10$disabled,
      _ref10$inverse = _ref10.inverse,
      inverse = _ref10$inverse === void 0 ? false : _ref10$inverse;

  if (inverse) {
    return {
      bg: disabled ? "input.inverse.bgDisabled" : "input.inverse.bg",
      borderColor: invalid ? "input.inverse.borderError" : "input.inverse.border",
      color: getColor$2(invalid, disabled, true)
    };
  }

  return {
    bg: disabled ? "input.default.bgDisabled" : "input.default.bg",
    borderColor: invalid ? "input.default.borderError" : "input.default.border",
    color: getColor$2(invalid, disabled)
  };
};

var Input = forwardRef(function (_ref11, ref) {
  var id = _ref11.id,
      theme$1 = _ref11.theme,
      name = _ref11.name,
      value = _ref11.value,
      placeholder = _ref11.placeholder,
      className = _ref11.className,
      invalid = _ref11.invalid,
      disabled = _ref11.disabled,
      inverse = _ref11.inverse,
      onFocus = _ref11.onFocus,
      onBlur = _ref11.onBlur,
      onChange = _ref11.onChange;
  var inputHTMLAttributes = {
    id: id,
    placeholder: placeholder,
    className: className,
    disabled: disabled,
    name: name,
    value: value,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur
  };
  return jsx(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: jsx("input", Object.assign({
      ref: ref,
      type: "text"
    }, inputHTMLAttributes, {
      sx: _objectSpread({
        // we need these because we need token values in calculations
        "--input-padding": function inputPadding(theme) {
          return (theme.space || {})["inc30"];
        },
        "--invalid-input-padding": function invalidInputPadding(theme) {
          return (theme.space || {})["inc70"];
        },
        "--border-width": function borderWidth(theme) {
          return (theme.borderWidths || {})["inc10"];
        },
        "&": {
          cursor: disabled ? "not-allowed" : "default",
          outline: "none",
          fontSize: "inc20",
          fontFamily: "body",
          fontWeight: "300",
          lineHeight: "inc00",
          borderRadius: "input",
          borderStyle: "solid",
          borderWidth: "inc10",
          boxSizing: "border-box",
          height: "inc50",
          py: "calc(var(--input-padding) - var(--border-width))",
          paddingLeft: "calc(var(--input-padding) - var(--border-width))",
          paddingRight: "calc(var(--".concat(invalid ? "invalid-input-padding" : "input-padding", ") - var(--border-width))")
        },
        "&::placeholder": {
          fontWeight: "300",
          color: inverse ? "input.inverse.text" : "input.default.text"
        }
      }, getVariantStyles$1({
        invalid: invalid,
        disabled: disabled,
        inverse: inverse
      }))
    }), void 0)
  }), void 0);
});
Input.displayName = "Input";

var getColor$1 = function getColor$1(small, invalid, disabled, inverse) {
  if (inverse) {
    if (small) {
      return "input.inverse.textSecondary";
    }

    if (disabled) {
      return "input.inverse.textSecondary";
    }

    return invalid ? "input.inverse.textError" : "input.inverse.text";
  }

  if (small) {
    return "input.default.textSecondary";
  }

  if (disabled) {
    return "text.neutral";
  }

  return invalid ? "input.default.textError" : "input.default.text";
};

var getVariantStyles = function getVariantStyles(_ref12) {
  var inverse = _ref12.inverse,
      disabled = _ref12.disabled,
      _ref12$invalid = _ref12.invalid,
      invalid = _ref12$invalid === void 0 ? false : _ref12$invalid,
      _ref12$small = _ref12.small,
      small = _ref12$small === void 0 ? false : _ref12$small;

  if (inverse) {
    return {
      color: getColor$1(small, invalid, disabled, true),
      "::before": {
        bg: disabled ? "input.inverse.bgDisabled" : "input.inverse.bg"
      }
    };
  }

  return {
    color: getColor$1(small, invalid, disabled),
    "::before": {
      bg: disabled ? "input.default.bgDisabled" : "input.default.bg"
    }
  };
};

var Label = function Label(_ref13) {
  var children = _ref13.children,
      small = _ref13.small,
      invalid = _ref13.invalid,
      inverse = _ref13.inverse,
      disabled = _ref13.disabled,
      htmlFor = _ref13.htmlFor;

  var _getVariantStyles = getVariantStyles({
    inverse: inverse,
    disabled: disabled,
    invalid: invalid,
    small: small
  }),
      color = _getVariantStyles.color,
      before = _getVariantStyles["::before"];

  return jsx("label", Object.assign({
    htmlFor: htmlFor,
    sx: {
      "--translate-x": function translateX() {
        var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return small ? (theme.space || {})["inc20"] : (theme.space || {})["inc30"];
      },
      "--max-width": function maxWidth() {
        var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return small ? (theme.space || {})["inc40"] : (theme.space || {})["inc50"];
      },
      zIndex: "0",
      pointerEvents: small ? null : "none",
      textTransform: "capitalize",
      cursor: disabled ? "not-allowed" : "default",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      paddingLeft: small ? "inc20" : 0,
      paddingRight: small ? "inc20" : "inc30",
      position: "absolute",
      willChange: "transform, color, font-size",
      maxWidth: "calc(100% - var(--max-width))",
      transform: "translateY(".concat(small ? "-7px" : "15px", ") translateX(var(--translate-x))"),
      transition: "transform 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, color 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, font-size 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms",
      fontSize: small ? "inc00" : "inc20",
      fontFamily: "body",
      "::before": _objectSpread({
        content: "''",
        position: "absolute",
        zIndex: "-1",
        width: "100%",
        height: small ? "1px" : "0px",
        bottom: "6px",
        left: 0
      }, before),
      color: color
    }
  }, {
    children: children
  }), void 0);
};

var X = function X(_ref14) {
  var inverse = _ref14.inverse;
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    sx: {
      position: "absolute",
      transform: "translateY(17px) translateX(-32px)",
      stroke: inverse ? "icon.errorInverse" : "icon.error"
    }
  }, {
    children: [jsx("path", {
      d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
    }, void 0), jsx("path", {
      d: "M10.0454 5.77875L5.77875 10.0454",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M5.77875 5.77875L10.0454 10.0454",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
};

var getColor = function getColor(inverse, invalid) {
  if (inverse) {
    return invalid ? "text.errorInverse" : "text.inverseSecondary";
  }

  return invalid ? "text.error" : "text.secondary";
};

var Helper = function Helper(_ref15) {
  var _ref15$inverse = _ref15.inverse,
      inverse = _ref15$inverse === void 0 ? false : _ref15$inverse,
      _ref15$invalid = _ref15.invalid,
      invalid = _ref15$invalid === void 0 ? false : _ref15$invalid,
      children = _ref15.children;
  return jsx("span", Object.assign({
    sx: {
      color: getColor(inverse, invalid),
      textTransform: "capitalize",
      fontFamily: "body",
      display: "block",
      marginTop: "inc20",
      fontSize: "inc10",
      lineHeight: "inc20"
    }
  }, {
    children: children
  }), void 0);
};

var TextInput = forwardRef(function (_ref16, ref) {
  var _ref16$inverse = _ref16.inverse,
      inverse = _ref16$inverse === void 0 ? false : _ref16$inverse,
      _ref16$theme = _ref16.theme,
      theme$1 = _ref16$theme === void 0 ? "default" : _ref16$theme,
      id = _ref16.id,
      _onChange = _ref16.onChange,
      props = _objectWithoutProperties(_ref16, _excluded);

  var _a;

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isFocused = _useState16[0],
      setIsFocused = _useState16[1];

  var _useState17 = useState(props.value),
      _useState18 = _slicedToArray(_useState17, 2),
      value = _useState18[0],
      setValue = _useState18[1];

  var idValue = id || ((_a = props.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(/\s/g, ""));
  return jsx(ThemeProvider, Object.assign({
    theme: theme$1 === "legacy" ? theme : defaultTheme
  }, {
    children: jsxs("div", Object.assign({
      sx: _objectSpread({
        display: "inline-block",
        position: "relative"
      }, props.wrapperStyles)
    }, {
      children: [!props.placeholder && props.name && jsx(Label, Object.assign({
        htmlFor: idValue,
        disabled: props.disabled,
        small: isFocused || !!value,
        inverse: inverse,
        invalid: props.invalid
      }, {
        children: props.name
      }), void 0), jsx(Input, Object.assign({
        ref: ref,
        id: idValue,
        inverse: inverse,
        placeholder: props.placeholder,
        sx: props.inputStyles
      }, props, {
        onChange: function onChange(e) {
          setValue(e.target.value);
          if (_onChange) _onChange(e);
        },
        onFocus: function onFocus() {
          return setIsFocused(true);
        },
        onBlur: function onBlur() {
          return setIsFocused(false);
        },
        theme: theme$1
      }), void 0), props.invalid && jsx(X, {
        inverse: inverse
      }, void 0), props.helper && jsx(Helper, Object.assign({
        invalid: props.invalid,
        inverse: inverse
      }, {
        children: props.helper
      }), void 0)]
    }), void 0)
  }), void 0);
});
TextInput.displayName = "TextInput";
var ENavLinkVariant;

(function (ENavLinkVariant) {
  ENavLinkVariant["HEADER"] = "header";
  ENavLinkVariant["SUBHEADER"] = "subheader";
})(ENavLinkVariant || (ENavLinkVariant = {}));

var NavLink = function NavLink(_ref17) {
  var href = _ref17.href,
      _ref17$onClick = _ref17.onClick,
      onClick = _ref17$onClick === void 0 ? function () {} : _ref17$onClick,
      tabIndex = _ref17.tabIndex,
      target = _ref17.target,
      text = _ref17.text,
      className = _ref17.className,
      _ref17$variant = _ref17.variant,
      variant = _ref17$variant === void 0 ? ENavLinkVariant.SUBHEADER : _ref17$variant;
  return jsx(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: jsxs("a", Object.assign({
      tabIndex: tabIndex,
      href: href,
      target: target,
      className: className,
      sx: {
        display: "flex",
        fontFamily: "body",
        fontWeight: variant === ENavLinkVariant.SUBHEADER ? "300" : "500",
        cursor: "pointer",
        textDecoration: "none",
        position: "relative",
        alignItems: "center",
        alignContent: "flex-start",
        letterSpacing: "unset",
        ":hover": {
          textDecoration: "none",
          color: "link.navigation.textSelected"
        },
        ":focus-visible": {
          outline: "-webkit-focus-ring-color auto 1px"
        },
        fontSize: "inc20",
        lineHeight: "inc30",
        ".textlink-arrow-class": {
          fontFamily: "Arial,sans-serif",
          left: variant === ENavLinkVariant.HEADER ? "0px" : "-50px"
        },
        "&:hover .textlink-arrow-class": {
          left: "0",
          WebkitAnimation: "linear 1 alternate",
          WebkitAnimationName: "runLink",
          WebkitAnimationDuration: theme.motion.linkAnimation,
          "@-webkit-keyframes runLink": {
            "0%": {
              left: "-100px"
            },
            "100%": {
              left: "0"
            }
          }
        }
      }
    }, {
      children: [text, jsx("span", Object.assign({
        sx: {
          minWidth: "24px",
          minHeight: theme.lineHeights.inc30,
          overflow: "hidden",
          position: "relative",
          display: "inline-block",
          marginLeft: "inc30",
          color: "link.cta.default.icon"
        }
      }, {
        children: jsx("span", Object.assign({
          "aria-hidden": "true",
          className: "textlink-arrow-class",
          sx: {
            display: "inline-block",
            position: "absolute",
            fontFamily: "Arial, sans-serif",
            left: "-100px",
            fontSize: "inc20",
            lineHeight: "inc30",
            color: "green50"
          }
        }, {
          children: "\u2192"
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var getSearchURL = function getSearchURL(property, options, docsBaseUrl) {
  var _a;

  var optionKey = (_a = options.find(function (el) {
    return el.value === property;
  })) === null || _a === void 0 ? void 0 : _a.universalKey;
  var docsSearchUrl = "https://mongodb.com/docs/search/";

  switch (optionKey) {
    case "DOTCOM":
      return "https://www.mongodb.com/search";

    case "BLOG":
      return "https://www.mongodb.com/blog/search";

    case "DOCS":
      return standardizeDocsUrl(docsSearchUrl, docsBaseUrl);

    case "REALM":
      return standardizeDocsUrl(docsSearchUrl, docsBaseUrl);

    case "DEVHUB":
      return "https://developer.mongodb.com/learn#main";

    case "COMMUNITY":
      return "https://www.mongodb.com/community/forums/search";

    case "UNIVERSITY":
      return "https://learn.mongodb.com/catalog";

    default:
      return "https://www.mongodb.com/search";
  }
};

var getQueryStrings = function getQueryStrings(property, query, options, searchParams) {
  var _a;

  var optionKey = (_a = options.find(function (el) {
    return el.value === property;
  })) === null || _a === void 0 ? void 0 : _a.universalKey;
  var queryStrings = [];

  switch (optionKey) {
    case "DOTCOM":
      queryStrings = [{
        param: "addsearch",
        value: query
      }];
      return [{
        param: "addsearch",
        value: query
      }];

    case "BLOG":
      queryStrings = [{
        param: undefined,
        value: query
      }];
      break;

    case "DOCS":
      queryStrings = [{
        param: "q",
        value: query
      }];
      break;

    case "REALM":
      queryStrings = [{
        param: "q",
        value: query
      }, {
        param: "searchProperty",
        value: "realm-master"
      }];
      break;

    case "DEVHUB":
      queryStrings = [{
        param: "text",
        value: query
      }, {
        param: "content",
        value: "Articles"
      }];
      break;

    case "COMMUNITY":
      queryStrings = [{
        param: "q",
        value: query
      }];
      break;

    case "UNIVERSITY":
      queryStrings = [{
        param: "query",
        value: query
      }];
      break;

    default:
      queryStrings = [{
        param: "addsearch",
        value: query
      }];
  } // Prevent a property from overriding parameters specified within queryStrings.
  // Hardcoded queryStrings params are critical for expected site behavior.


  var uniqueParams = searchParams ? searchParams.filter(function (item) {
    return !queryStrings.some(function (e) {
      return e.param === item.param;
    });
  }) : [];
  return [].concat(_toConsumableArray(queryStrings), _toConsumableArray(uniqueParams));
};

var getPlaceholderText = function getPlaceholderText(selectedProperty, options) {
  var _a;

  return (_a = options.find(function (el) {
    return el.value === selectedProperty;
  })) === null || _a === void 0 ? void 0 : _a.placeholder;
};

var metadataParams = function metadataParams(name, property) {
  var mappedName = getOptionUniversalKey(name);
  return mappedName === (property === null || property === void 0 ? void 0 : property.name) && (property === null || property === void 0 ? void 0 : property.name) ? property.searchParams : [];
};

function debounce(func) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
  var timer;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(void 0, args);
    }, timeout);
  };

  debounced.cancel = function () {
    clearTimeout(timer);
  };

  return debounced;
}

var ASSETS_URL_PREFIX = "https://webimages.mongodb.com/_com_assets/cms/";
var COMMON_NAVIGATION_TRACKING_PROPS = {
  category: "navigation"
};
var COMMON_FOOTER_TRACKING_PROPS = {
  category: "navigation footer"
};
var ETrackingEvents;

(function (ETrackingEvents) {
  ETrackingEvents["DROPDOWN_APPEARS"] = "Dropdown Appears";
  ETrackingEvents["LINK_CLICK"] = "Internal Click";
  ETrackingEvents["MOUSE_HOVER"] = "Mouse Hover";
  ETrackingEvents["SEARCH"] = "Search";
})(ETrackingEvents || (ETrackingEvents = {}));

var mdbTrack = function mdbTrack(name, properties) {
  var _a;

  if (window === null || window === void 0 ? void 0 : window.mdbTrack) {
    window.mdbTrack(name, _objectSpread(_objectSpread({}, properties), {}, {
      url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href
    }));
  }
};

var ButtonWrapper = function ButtonWrapper(_ref18) {
  var tabIndex = _ref18.tabIndex,
      theme = _ref18.theme,
      variant = _ref18.variant,
      href = _ref18.href,
      customWrapperStyles = _ref18.customWrapperStyles,
      customStyles = _ref18.customStyles,
      onMouseEnter = _ref18.onMouseEnter,
      onClick = _ref18.onClick,
      inverse = _ref18.inverse,
      sx = _ref18.sx,
      target = _ref18.target,
      type = _ref18.type,
      children = _ref18.children;
  return jsx(ThemeProvider, Object.assign({
    theme: defaultTheme
  }, {
    children: jsx(Button$1, Object.assign({
      tabIndex: tabIndex,
      theme: theme,
      variant: variant,
      target: target,
      href: href,
      sx: sx,
      customWrapperStyles: customWrapperStyles,
      customStyles: customStyles,
      onMouseEnter: onMouseEnter,
      onClick: onClick,
      inverse: inverse,
      type: type
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var NavSearch = forwardRef(function (_ref19, ref) {
  var className = _ref19.className,
      content = _ref19.content,
      animating = _ref19.animating,
      visible = _ref19.visible,
      property = _ref19.property,
      floraTheme = _ref19.floraTheme,
      docsBaseUrl = _ref19.docsBaseUrl;

  var _a;

  var options = content.secondary.search.options;
  var optionsArray = options.map(function (el) {
    return el.value;
  });
  var defaultOption = ((_a = options.find(function (el) {
    return el.universalKey === (property === null || property === void 0 ? void 0 : property.name);
  })) === null || _a === void 0 ? void 0 : _a.value) || optionsArray[0];

  var _useState19 = useState(defaultOption),
      _useState20 = _slicedToArray(_useState19, 2),
      selectedProperty = _useState20[0],
      setSelectedProperty = _useState20[1];

  var _useState21 = useState(""),
      _useState22 = _slicedToArray(_useState21, 2),
      query = _useState22[0],
      setQuery = _useState22[1];

  var inputRef = useRef(null);
  var boxRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      addEventListener: function addEventListener(type, listener, options) {
        var _a;

        (_a = boxRef === null || boxRef === void 0 ? void 0 : boxRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(type, listener, options);
      },
      focus: function focus() {
        setTimeout(function () {
          var _a;

          return (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 100);
      }
    };
  }, []);
  useEffect(function () {
    setSelectedProperty(defaultOption);
  }, [content]);

  var handlePropertySelection = function handlePropertySelection(value) {
    mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
      title: "Select Search Domain",
      text: value
    }));
    setSelectedProperty(value);
  };

  var startTyping = debounce(function (func, value) {
    if (typeof func === "function") func(value);
  });

  var trackTyping = function trackTyping(query) {
    mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
      title: "Typing Search",
      query: query
    }));
  };

  var handleInputChange = useCallback(function (e) {
    setQuery(e.currentTarget.value);
    startTyping(trackTyping, e.currentTarget.value);
  }, []);
  var selectedTheme = floraTheme === "legacy" ? theme : defaultTheme;
  return jsxs(ThemeProvider, Object.assign({
    theme: selectedTheme
  }, {
    children: [jsx(Box, {
      sx: {
        backgroundColor: "black00",
        opacity: visible ? "0.5" : "0",
        transition: "opacity ".concat(selectedTheme.motion.inc20),
        width: "100%",
        height: "inc100",
        position: "absolute",
        left: "0",
        zIndex: !visible && !animating ? "-1" : "1",
        top: "0"
      }
    }, void 0), jsx(Box, Object.assign({
      sx: {
        position: !visible && !animating ? "absolute" : "relative",
        visibility: !visible && !animating ? "hidden" : "visible",
        zIndex: !visible && !animating ? "-1" : "999"
      }
    }, {
      children: jsx("form", Object.assign({
        role: "search",
        method: "GET",
        action: selectedProperty === "Blog" ? getSearchURL(selectedProperty, options, docsBaseUrl) + "/" + query : getSearchURL(selectedProperty, options, docsBaseUrl),
        className: className,
        onSubmit: function onSubmit() {
          mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: "Submit Search",
            query: query
          }));
        },
        sx: {
          position: "relative",
          width: "90%",
          top: 0,
          height: "inc100",
          display: ["none", null, null, "flex"],
          alignItems: "center",
          paddingLeft: "inc30",
          paddingRight: "inc40"
        }
      }, {
        children: jsxs(Box, Object.assign({
          sx: {
            zIndex: "2",
            marginTop: visible ? "1px" : "-500px",
            transition: "margin-top ".concat(selectedTheme.motion.inc20),
            width: "100%",
            display: "grid",
            gridTemplateColumns: "3fr 1fr",
            gridGap: "inc20",
            paddingRight: "inc40"
          },
          ref: boxRef
        }, {
          children: [jsx(TextInput, {
            ref: inputRef,
            theme: "legacy",
            placeholder: getPlaceholderText(selectedProperty, options),
            inputStyles: {
              width: "100%"
            },
            wrapperStyles: {
              width: "100%",
              zIndex: "2"
            },
            value: query,
            onChange: handleInputChange
          }, void 0), jsxs(Box, Object.assign({
            sx: {
              display: "flex",
              minWidth: "298px",
              zIndex: "2"
            }
          }, {
            children: [jsx(Select, {
              theme: "legacy",
              value: selectedProperty,
              onSelect: handlePropertySelection,
              width: "250px",
              inverse: false,
              invalid: false,
              variant: "default",
              options: optionsArray,
              onOpen: function onOpen() {
                mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                  title: "Open Search Domain Selector"
                }));
              }
            }, "navbar-property-select-".concat(selectedProperty)), getQueryStrings(selectedProperty, query, options, metadataParams(selectedProperty, property)).map(function (querystring) {
              return querystring.param && jsx("input", {
                type: "hidden",
                id: querystring.param,
                name: querystring.param,
                value: querystring.value
              }, "navsearch-form-".concat(querystring.param));
            }), jsx(ButtonWrapper, Object.assign({
              variant: "secondary",
              "aria-label": "Submit Search",
              customStyles: {
                padding: "14px 14px",
                marginLeft: "inc10"
              },
              theme: "default",
              type: "submit"
            }, {
              children: jsx("img", {
                sx: {
                  maxWidth: "unset"
                },
                alt: "search icon",
                src: "https://webimages.mongodb.com/_com_assets/cms/krc3hljsdwdfd2w5d-web-actions-search.svg?auto=format%252Ccompress"
              }, void 0)
            }), void 0)]
          }), void 0)]
        }), void 0)
      }), void 0)
    }), void 0)]
  }), void 0);
});
NavSearch.displayName = "NavSearch";
var EBackground;

(function (EBackground) {
  EBackground["BACKGROUND_DEFAULT"] = "default";
  EBackground["BACKGROUND_ALT"] = "gray";
})(EBackground || (EBackground = {}));

var OUTER_GRID_MAX_WIDTH = 216;
var OUTER_GRID_SMALL_WIDTH = 140;
var RESPONSIVE_GRID_WIDTH = [OUTER_GRID_SMALL_WIDTH, null, null, null, null, OUTER_GRID_MAX_WIDTH];
var GRID_GAP = 40;

var times = function times(count, func) {
  var i = 0;
  var results = [];

  while (i < count) {
    results.push(func(i));
    i += 1;
  }

  return results;
};

var Header = function Header(props) {
  var header = props;
  return jsxs(Box$1, Object.assign({
    sx: {
      flexBasis: "100%",
      minWidth: RESPONSIVE_GRID_WIDTH,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    }
  }, {
    children: [jsxs(Box$1, {
      children: [header.href ? jsx(NavLink, {
        text: header.title,
        variant: ENavLinkVariant.HEADER,
        target: header.target,
        // this class name is required by University to animate this element themselves
        className: "textlink-title-wrapper",
        sx: {
          color: "black80",
          textDecoration: "none",
          fontWeight: "500",
          fontSize: "inc20",
          lineHeight: "inc30",
          letterSpacing: "unset"
        },
        href: header.href,
        onClick: function onClick() {
          mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: header.title,
            href: header.href,
            label: header.title,
            position: header.index,
            text: header.description
          }));
        }
      }, void 0) : jsx("p", Object.assign({
        sx: {
          color: "black80",
          marginBottom: "inc10",
          marginTop: "inc00",
          fontWeight: "500",
          fontSize: "inc20",
          lineHeight: "inc30"
        }
      }, {
        children: header.title
      }), void 0), jsx("p", Object.assign({
        sx: {
          marginTop: "inc00",
          marginBottom: "inc00",
          color: "black50",
          fontWeight: "300",
          fontSize: "14px",
          lineHeight: "inc30",
          display: ["none", null, null, null, null, "block"]
        }
      }, {
        children: header.description
      }), void 0)]
    }, void 0), header.hasDivider && jsx(Divider, {
      color: "".concat(theme.colors.black30),
      marginTop: "".concat(theme.space.inc30)
    }, void 0)]
  }), void 0);
};

var Button = function Button(_ref20) {
  var _ref20$floraTheme = _ref20.floraTheme,
      floraTheme = _ref20$floraTheme === void 0 ? "default" : _ref20$floraTheme,
      href = _ref20.href,
      title = _ref20.title,
      target = _ref20.target,
      index = _ref20.index,
      variant = _ref20.variant;
  return jsx(ButtonWrapper, Object.assign({
    theme: floraTheme,
    customWrapperStyles: {
      justifySelf: "flex-start",
      alignSelf: "flex-end"
    },
    href: href,
    target: target,
    variant: floraTheme === "default" ? variant : "secondary",
    onClick: function onClick() {
      mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
        title: title,
        href: href,
        label: title,
        position: index
      }));
    }
  }, {
    children: title
  }), void 0);
};

var NavCta = function NavCta(_ref21) {
  var header = _ref21.header,
      button = _ref21.button,
      index = _ref21.index,
      _ref21$className = _ref21.className,
      className = _ref21$className === void 0 ? "" : _ref21$className,
      _ref21$spannedColumns = _ref21.spannedColumns,
      spannedColumns = _ref21$spannedColumns === void 0 ? 1 : _ref21$spannedColumns,
      hasDivider = _ref21.hasDivider,
      _ref21$isSingle = _ref21.isSingle,
      isSingle = _ref21$isSingle === void 0 ? false : _ref21$isSingle,
      _ref21$floraTheme = _ref21.floraTheme,
      floraTheme = _ref21$floraTheme === void 0 ? "default" : _ref21$floraTheme;

  var calculateGridLayout = function calculateGridLayout() {
    return ["".concat(spannedColumns * OUTER_GRID_SMALL_WIDTH, "px"), null, null, null, null, "".concat(spannedColumns * OUTER_GRID_MAX_WIDTH, "px")];
  };

  var gridTemplateColumns = calculateGridLayout();
  return jsxs(Fragment, {
    children: [jsxs(Box$1, Object.assign({
      sx: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexBasis: "100%"
      }
    }, {
      children: [jsx(Box$1, {
        children: jsx("div", Object.assign({
          sx: {
            display: "grid",
            gridTemplateColumns: gridTemplateColumns,
            gap: GRID_GAP
          },
          className: className
        }, {
          children: jsx(Header, Object.assign({}, header, {
            index: index
          }), void 0)
        }), void 0)
      }, void 0), jsx("div", Object.assign({
        className: className,
        sx: {
          display: "grid",
          gridTemplateColumns: gridTemplateColumns,
          gap: GRID_GAP,
          paddingTop: theme.space.inc30
        }
      }, {
        children: jsx(Button, Object.assign({}, button, {
          index: index,
          floraTheme: "default"
        }), void 0)
      }), void 0)]
    }), void 0), hasDivider && !isSingle ? jsx(Divider, {
      color: theme.colors.black30,
      marginTop: theme.space.inc30,
      marginBottom: theme.space.inc20
    }, void 0) : null]
  }, void 0);
};

var NavDropdown = function NavDropdown(_ref22) {
  var _ref22$className = _ref22.className,
      className = _ref22$className === void 0 ? "" : _ref22$className,
      _ref22$floraTheme = _ref22.floraTheme,
      floraTheme = _ref22$floraTheme === void 0 ? "default" : _ref22$floraTheme,
      content = _ref22.content,
      _ref22$hidden = _ref22.hidden,
      hidden = _ref22$hidden === void 0 ? true : _ref22$hidden;
  var processedData = content.sections.map(function (section) {
    var data = section.columns.map(function (column) {
      return {
        header: column.header,
        spannedColumns: column.subColumns.length || 1,
        subColumns: column.subColumns,
        button: column.button
      };
    });
    return {
      data: data,
      background: section.background,
      ctas: section.ctas
    };
  });

  var calculateHeadersColumns = function calculateHeadersColumns(section, columnWidth) {
    var columnsString = "";
    section.data.forEach(function (data) {
      columnsString += "".concat(data.spannedColumns * columnWidth + (data.spannedColumns > 1 ? (data.spannedColumns - 1) * GRID_GAP : 0), "px ");
    });
    return columnsString.trim();
  };

  var calculateInnerContentColumns = function calculateInnerContentColumns(data) {
    var columnsString = "";
    times(data.spannedColumns, function () {
      columnsString += "1fr ";
    });
    return columnsString.trim();
  };

  var responsiveHeaderColumns = function responsiveHeaderColumns(section) {
    return [calculateHeadersColumns(section, OUTER_GRID_SMALL_WIDTH), null, null, null, null, calculateHeadersColumns(section, OUTER_GRID_MAX_WIDTH)];
  };

  return jsx(Box, Object.assign({
    sx: {
      margin: ["0 auto", null, null, null, "0 auto 0 182px", "0 auto"],
      display: ["none", null, null, "flex"],
      visibility: hidden ? "hidden" : "visible",
      // following three lines are required for Docs relative positioned integration.
      position: "absolute",
      left: ["50%", null, null, null, "0", "50%"],
      transform: ["translateX(-50%)", null, null, null, "translateX(0)", "translateX(-50%)"],
      backgroundColor: "black00",
      borderRadius: "0 0 ".concat(theme.radii.inc40, " ").concat(theme.radii.inc40),
      border: "solid ".concat(theme.colors.border.default),
      borderWidth: "0 1px 1px 1px",
      fontFamily: "akzidenz-grotesk-std",
      fontWeight: "300",
      overflow: "hidden",
      width: "fit-content",
      "@media screen and (min-width: 1480px)": {
        // this breakpoint is not tokenized yet
        margin: "0 auto 0 91px",
        left: "0",
        transform: "translateX(0)"
      },
      "@media screen and (min-width: 1580px)": {
        // this breakpoint is not tokenized yet
        margin: "0 auto 0 182px"
      },
      maxWidth: ["992px", null, null, null, null, "1500px"] // needs to be updated to use token

    }
  }, {
    children: processedData.map(function (section, index) {
      var _section$data = section.data,
          data = _section$data === void 0 ? [] : _section$data,
          _section$ctas = section.ctas,
          ctas = _section$ctas === void 0 ? [] : _section$ctas;
      return jsx(Box, Object.assign({
        sx: {
          padding: "inc60",
          backgroundColor: section.background === EBackground.BACKGROUND_DEFAULT ? "black00" : "black10",
          border: section.background === EBackground.BACKGROUND_ALT ? "solid ".concat(theme.colors.border.default) : "none",
          borderWidth: section.background === EBackground.BACKGROUND_ALT ? index > 0 && index < processedData.length - 1 ? "0 1px 0 1px " : index === processedData.length - 1 ? "0 0 0 1px" : index === 0 ? "0 1px 0 0" : "none" : "none",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }
      }, {
        children: ctas.length ? ctas.map(function (cta, index) {
          return jsx(NavCta, {
            header: cta.header,
            button: cta.button,
            className: className,
            index: index,
            hasDivider: cta.hasDivider,
            isSingle: ctas.length === 1,
            floraTheme: floraTheme
          }, "navdropdown-cta-".concat(cta.header.title, "-").concat(index));
        }) : jsxs(Fragment, {
          children: [jsxs(Box, {
            children: [jsx("div", Object.assign({
              sx: {
                display: "grid",
                gridTemplateColumns: responsiveHeaderColumns(section),
                gap: GRID_GAP
              },
              className: className
            }, {
              children: data.map(function (data, index) {
                var header = data.header;
                return jsx(Header, Object.assign({}, header, {
                  index: index
                }), "navdropdown-box-".concat(header.title, "-").concat(index));
              })
            }), void 0), jsx("div", Object.assign({
              sx: {
                minWidth: RESPONSIVE_GRID_WIDTH,
                display: "grid",
                gridTemplateColumns: responsiveHeaderColumns(section),
                gap: "0 ".concat(GRID_GAP, "px")
              }
            }, {
              children: data.map(function (data, index) {
                return jsx("div", Object.assign({
                  sx: {
                    gridAutoRows: "min-content",
                    display: "grid",
                    gridTemplateColumns: calculateInnerContentColumns(data),
                    gap: "0 ".concat(GRID_GAP, "px")
                  }
                }, {
                  children: data.subColumns.map(function (links, index) {
                    return jsx("ul", Object.assign({
                      itemScope: true,
                      itemType: "https://schema.org/SiteNavigationElement",
                      role: "menu",
                      sx: {
                        display: "flex",
                        flexDirection: "column",
                        minWidth: RESPONSIVE_GRID_WIDTH,
                        listStyle: "none",
                        margin: "0",
                        padding: "0"
                      }
                    }, {
                      children: links.map(function (link, index) {
                        return jsx("li", Object.assign({
                          itemProp: "name",
                          role: "menuitem",
                          sx: {
                            marginTop: "inc40"
                          }
                        }, {
                          children: link.href ? jsx(NavLink, {
                            href: link.href,
                            target: link.target,
                            text: link.title,
                            // this class name is required by University to animate this element themselves
                            className: "textlink-link-wrapper",
                            sx: {
                              textDecoration: "none",
                              color: "black80",
                              letterSpacing: "unset",
                              width: [OUTER_GRID_SMALL_WIDTH, null, null, null, null, OUTER_GRID_MAX_WIDTH]
                            },
                            onClick: function onClick() {
                              mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                                title: link.title,
                                href: link.href,
                                label: link.title,
                                position: index
                              }));
                            }
                          }, void 0) : jsx("span", Object.assign({
                            tabIndex: 0,
                            sx: {
                              marginTop: "inc40",
                              textDecoration: "none",
                              color: "black80",
                              width: [OUTER_GRID_SMALL_WIDTH, null, null, null, null, OUTER_GRID_MAX_WIDTH]
                            },
                            onClick: function onClick() {
                              mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                                title: link.title,
                                href: link.href,
                                label: link.title,
                                position: index
                              }));
                            }
                          }, {
                            children: link.title
                          }), void 0)
                        }), "navdropdown-link-".concat(link.title, "-").concat(index));
                      })
                    }), "navdropdown-content-box-".concat(index));
                  })
                }), "navdropdown-inner-grid-".concat(index));
              })
            }), void 0)]
          }, void 0), jsx("div", Object.assign({
            className: className,
            sx: {
              display: "grid",
              gridTemplateColumns: responsiveHeaderColumns(section),
              gap: GRID_GAP
            }
          }, {
            children: data.map(function (data, index) {
              var button = data.button;
              if (!button) return jsx("span", {}, "navdropdown-button-".concat(index));else return jsx(Button, Object.assign({}, button, {
                index: index,
                floraTheme: "default"
              }), "navdropdown-button-".concat(index));
            })
          }), void 0)]
        }, void 0)
      }), "navdropdown-section-".concat(index));
    })
  }), void 0);
};

var noop = function noop() {};

var Desktop = function Desktop(_ref23) {
  var className = _ref23.className,
      content = _ref23.content,
      property = _ref23.property,
      signInUrl = _ref23.signInUrl,
      hideTryFree = _ref23.hideTryFree,
      hideSignIn = _ref23.hideSignIn,
      hideSearch = _ref23.hideSearch,
      _ref23$floraTheme = _ref23.floraTheme,
      floraTheme = _ref23$floraTheme === void 0 ? "default" : _ref23$floraTheme,
      docsBaseUrl = _ref23.docsBaseUrl;

  var _useState23 = useState(""),
      _useState24 = _slicedToArray(_useState23, 2),
      activeDropdown = _useState24[0],
      setActiveDropdown = _useState24[1];

  var _useState25 = useState(""),
      _useState26 = _slicedToArray(_useState25, 2),
      tabToHighlight = _useState26[0],
      setTabToHighlight = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      showNavSearch = _useState28[0],
      setShowNavSearch = _useState28[1];

  var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      isAnimating = _useState30[0],
      setIsAnimating = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      searchRefListener = _useState32[0],
      setSearchRefListener = _useState32[1];

  var _onMouseEnter = useRef(noop);

  var _onTouchStart = useRef(noop);

  var _onClick = useRef(noop);

  var _onMouseLeave = useRef(noop);

  var searchRef = useRef(null);
  var prevActiveDropDown = useRef("");
  var disableSignIn = hideSignIn || !content.secondary.login;
  var disableSearch = hideSearch || !content.secondary.search;
  var disableTryFree = hideTryFree || !content.secondary.try;

  var onLinkClick = function onLinkClick(_ref24) {
    var title = _ref24.title,
        href = _ref24.href,
        index = _ref24.index;

    if (href) {
      mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
        title: title,
        href: href,
        label: title,
        position: index
      }));
      return;
    }
  };

  useEffect(function () {
    prevActiveDropDown.current = activeDropdown;
  }, [activeDropdown]);
  useEffect(function () {
    var transitionEndHandler = function transitionEndHandler() {
      setIsAnimating(false);
    };

    if (searchRef === null || searchRef === void 0 ? void 0 : searchRef.current) {
      if (showNavSearch) setActiveDropdown("");

      if (!searchRefListener) {
        searchRef.current.addEventListener("transitionend", transitionEndHandler, {
          once: false
        });
        setSearchRefListener(true);
      }
    }
  }, [showNavSearch]);

  var handleSetShowNavSearch = function handleSetShowNavSearch() {
    var _a;

    setIsAnimating(true);

    if (!showNavSearch) {
      mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
        title: "Open Search"
      }));
      (_a = searchRef === null || searchRef === void 0 ? void 0 : searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }

    setShowNavSearch(!showNavSearch);
  };

  useEffect(function () {
    setTabToHighlight(function () {
      var linkIsInL2 = function linkIsInL2(column) {
        var _a, _b;

        return ((_a = column === null || column === void 0 ? void 0 : column.header) === null || _a === void 0 ? void 0 : _a.href) && window.location.href.split("?")[0] === ((_b = column === null || column === void 0 ? void 0 : column.header) === null || _b === void 0 ? void 0 : _b.href) || column.subColumns.some(function (subColumn) {
          return subColumn.flat().some(function (link) {
            return window.location.href.split("?")[0] === link.href;
          });
        });
      };

      return content === null || content === void 0 ? void 0 : content.primary.flatMap(function (dropdown) {
        var _a;

        return (_a = dropdown.dropdown) === null || _a === void 0 ? void 0 : _a.sections.flatMap(function (section) {
          var _a;

          var link = window.location.href.split("?")[0];
          var linkIsInHighlights = !!((_a = dropdown === null || dropdown === void 0 ? void 0 : dropdown.highlightUrls) === null || _a === void 0 ? void 0 : _a.some(function (url) {
            return link.includes(url);
          }));
          if (linkIsInHighlights || section.columns.some(function (column) {
            return linkIsInL2(column);
          })) return dropdown.title;
        });
      }).filter(function (el) {
        return el;
      })[0];
    }());

    if ("ontouchstart" in window) {
      _onTouchStart.current = function (_ref25) {
        var title = _ref25.title,
            activeDropdown = _ref25.activeDropdown,
            href = _ref25.href,
            index = _ref25.index;
        if (href) return;

        if (activeDropdown === title) {
          setActiveDropdown("");
        } else {
          setActiveDropdown(title);
          mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: title,
            position: index,
            nonInteraction: 1
          }));
        }
      };
    } else {
      _onMouseEnter.current = function (_ref26) {
        var title = _ref26.title,
            activeDropdown = _ref26.activeDropdown,
            href = _ref26.href,
            index = _ref26.index;

        if (href) {
          prevActiveDropDown.current = "";
          setActiveDropdown("");
          return;
        }

        if (title !== activeDropdown) {
          setActiveDropdown(title);
          mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: title,
            position: index,
            nonInteraction: 1
          }));
        }
      };

      _onClick.current = function (_ref27) {
        var title = _ref27.title,
            activeDropdown = _ref27.activeDropdown,
            href = _ref27.href,
            index = _ref27.index;

        if (href) {
          mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: title,
            href: href,
            label: title,
            position: index
          }));
          return;
        }

        if (activeDropdown === title) {
          setActiveDropdown("");
        } else {
          setActiveDropdown(title);
          mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: title,
            position: index,
            nonInteraction: 1
          }));
        }
      };

      _onMouseLeave.current = function (_ref28) {
        var href = _ref28.href;
        if (href) return;
      };
    }
  }, []); // setting opacity 0 between 0%-99.99% simulates the delay since `animation-delay` effect can't be applied to component mount.
  // @Todo: after the dropdown is rendered in the DOM, we shuold use `animation-delay` instead.

  var fadeIn = keyframes({
    "0%": {
      opacity: 0,
      visibility: "hidden"
    },
    "99.99%": {
      opacity: 0,
      visibility: "hidden"
    },
    "100%": {
      opacity: 1,
      visibility: "visible"
    }
  });
  return jsx(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: jsxs(Box, Object.assign({
      sx: {
        backgroundColor: "black00",
        display: "flex",
        alignItems: "center",
        fontFamily: "akzidenz-grotesk-std",
        border: "solid ".concat(theme.colors.border.default),
        borderWidth: "0 0 1px 0",
        fontWeight: "300",
        height: "inc100",
        paddingLeft: "inc50"
      },
      className: className
    }, {
      children: [jsx(MDBLogo, {
        theme: floraTheme,
        sx: {
          fontSize: "inc10",
          lineHeight: "37px",
          height: "43px" // these values are needed for cross-domain consistency

        },
        variant: ELogoVariant.HORIZONTAL_DEFAULT,
        href: "https://www.mongodb.com",
        imageWidth: "150px"
      }, void 0), jsxs(Box, Object.assign({
        sx: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%"
        }
      }, {
        children: [disableSearch ? null : jsx(NavSearch, {
          floraTheme: floraTheme,
          content: content,
          visible: showNavSearch,
          animating: isAnimating,
          ref: searchRef,
          property: property,
          docsBaseUrl: docsBaseUrl
        }, void 0), jsx("ul", Object.assign({
          sx: {
            margin: "0",
            marginLeft: "inc30",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "inc100",
            listStyle: "none",
            padding: "0",
            opacity: showNavSearch ? "0" : "1",
            pointerEvents: showNavSearch ? "none" : "initial",
            willChange: "opacity",
            transition: "opacity ".concat(theme.motion.inc20),
            position: showNavSearch || isAnimating ? "absolute" : "unset"
          },
          onMouseLeave: function onMouseLeave() {
            prevActiveDropDown.current = "";
            setActiveDropdown("");
          }
        }, {
          children: content.primary.map(function (_ref29, index) {
            var href = _ref29.href,
                title = _ref29.title,
                dropdown = _ref29.dropdown;
            var eventProps = {
              title: title,
              activeDropdown: activeDropdown,
              href: href,
              index: index
            };
            var shouldHighlight = activeDropdown === title || !activeDropdown && tabToHighlight === title;
            return jsxs("li", Object.assign({
              "data-highlighted": shouldHighlight,
              sx: {
                paddingLeft: "inc40",
                paddingRight: "inc40",
                ":hover": {
                  "> div": {
                    animation: !prevActiveDropDown.current ? "".concat(fadeIn, " ").concat(theme.motion.inc40) : ""
                  },
                  "> button::after": {
                    animation: title === activeDropdown && !prevActiveDropDown.current ? "".concat(fadeIn, " ").concat(theme.motion.inc40) : ""
                  }
                },
                "> button::after": shouldHighlight ? {
                  display: "flex",
                  content: '""',
                  height: "5px",
                  position: "absolute",
                  bottom: "0",
                  left: "-24px",
                  right: "-24px",
                  backgroundColor: "green50"
                } : {
                  content: '""'
                }
              },
              onMouseEnter: function onMouseEnter() {
                return _onMouseEnter.current(eventProps);
              },
              onMouseLeave: function onMouseLeave() {
                return _onMouseLeave.current(eventProps);
              }
            }, {
              children: [jsx(Link, Object.assign({
                tabIndex: showNavSearch ? -1 : 0,
                theme: "legacy",
                variant: ELinkVariant.SMALL,
                navItem: true,
                sx: {
                  position: "relative",
                  height: "inc100",
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  fontWeight: "300",
                  letterSpacing: "unset",
                  ":hover": {
                    textDecoration: "none",
                    color: "black80"
                  },
                  ":focus-visible": {
                    outline: "-webkit-focus-ring-color auto 1px"
                  },
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                },
                href: href,
                // on touch devices, when you tap a button, it triggers both a click and a mouse enter event, this causes the dropdown to glitch, thus the following event listener.
                onTouchStart: function onTouchStart() {
                  return _onTouchStart.current(eventProps);
                },
                onClick: function onClick() {
                  if (href) onLinkClick(eventProps);else _onClick.current(eventProps);
                }
              }, {
                children: title
              }), void 0), dropdown && jsx(NavDropdown, {
                floraTheme: floraTheme,
                content: dropdown,
                hidden: title !== activeDropdown
              }, void 0)]
            }), "nav-main-link-".concat(title));
          })
        }), void 0), jsxs(Box, Object.assign({
          sx: {
            marginRight: "inc60",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }
        }, {
          children: [disableSearch ? null : jsx("button", Object.assign({
            onClick: function onClick() {
              return handleSetShowNavSearch();
            },
            "aria-label": showNavSearch ? "Close Search" : "Open Search",
            sx: {
              border: "none",
              background: "none",
              outline: "none",
              marginRight: "inc50",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: "1",
              height: "inc100",
              width: "inc30",
              ":focus-visible": {
                outline: "-webkit-focus-ring-color auto 1px"
              }
            }
          }, {
            children: jsx("img", {
              src: !showNavSearch && "https://webimages.mongodb.com/_com_assets/cms/kq2qmrej7f2j8oxpd-Search.svg?auto=format%252Ccompress" || "https://webimages.mongodb.com/_com_assets/cms/kq2rzdva9b720s30j-close_x.svg?auto=format%252Ccompress"
            }, void 0)
          }), void 0), disableSignIn ? null : jsx(Link, Object.assign({
            tabIndex: showNavSearch ? -1 : 0,
            theme: "legacy",
            navItem: true,
            variant: ELinkVariant.SMALL,
            href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
            sx: {
              letterSpacing: "unset",
              marginRight: "inc60",
              color: "black80",
              textDecoration: "none"
            },
            onClick: function onClick() {
              mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                title: content.secondary.login.title,
                href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
                label: content.secondary.login.title
              }));
            }
          }, {
            children: content.secondary.login.title
          }), void 0), disableTryFree ? null : jsx(ButtonWrapper, Object.assign({
            tabIndex: showNavSearch ? -1 : 0,
            theme: floraTheme,
            variant: "primary",
            href: content.secondary.try.href,
            customWrapperStyles: {
              letterSpacing: "unset"
            },
            onClick: function onClick() {
              mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                title: content.secondary.try.title,
                href: content.secondary.try.href,
                label: content.secondary.try.title
              }));
            }
          }, {
            children: content.secondary.try.title
          }), void 0)]
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var SHIFT_AMOUNT = "350px";
var ANIMATION_BUFFER = 100;
var MOBILE_LEVEL_HEIGHT = 72;

var CloseIcon = function CloseIcon() {
  return jsx("img", {
    src: "".concat(ASSETS_URL_PREFIX, "kqmp60ceasl5pknl6-Vector%204.svg?auto=format%252Ccompress")
  }, void 0);
};

var OpenIcon = function OpenIcon() {
  return jsx("img", {
    src: "".concat(ASSETS_URL_PREFIX, "kqmf43vl96om2i6o1-open-green.svg?auto=format%252Ccompress")
  }, void 0);
};

var Description = function Description(_ref30) {
  var description = _ref30.description;
  if (!description) return null;
  return jsx("span", Object.assign({
    sx: {
      fontSize: "inc10",
      lineHeight: "inc30"
    }
  }, {
    children: description
  }), void 0);
};

var NavLevel = function NavLevel(_ref31) {
  var title = _ref31.title,
      href = _ref31.href,
      target = _ref31.target,
      description = _ref31.description,
      index = _ref31.index,
      onOpen = _ref31.onOpen,
      open = _ref31.open,
      openParent = _ref31.openParent,
      L1columns = _ref31.L1columns,
      L2subcolumns = _ref31.L2subcolumns,
      button = _ref31.button,
      L1Ref = _ref31.L1Ref,
      currentLevel = _ref31.currentLevel,
      menuRef = _ref31.menuRef;

  var _useState33 = useState(""),
      _useState34 = _slicedToArray(_useState33, 2),
      activeChild = _useState34[0],
      setActiveChild = _useState34[1];

  var isL1 = currentLevel === "l1";
  var isL2 = currentLevel === "l2";

  var getLinkStyles = function getLinkStyles() {
    switch (currentLevel) {
      case "l1":
        return {
          padding: "inc40",
          color: "black00",
          background: "none",
          border: "none",
          fontWeight: "500",
          fontFamily: "akzidenz-grotesk-std",
          textDecoration: "none",
          fontSize: "inc30",
          lineHeight: "inc00",
          flex: "1"
        };

      case "l2":
        return {
          margin: description ? "inc40" : "inc30",
          marginRight: "inc00",
          marginLeft: "inc00",
          color: "black00",
          background: "none",
          border: "none",
          fontWeight: "300",
          fontFamily: "akzidenz-grotesk-std",
          textDecoration: "none",
          fontSize: "inc30",
          lineHeight: "inc00",
          borderRight: "1px solid ".concat(theme.colors.black80)
        };

      case "l3":
        return {
          margin: "inc30",
          marginRight: "inc00",
          color: "black00",
          background: "none",
          border: "none",
          fontWeight: "300",
          textDecoration: "none",
          fontSize: "inc30",
          lineHeight: "inc00",
          borderRight: "1px solid ".concat(theme.colors.black80)
        };
    }
  };

  var getButtonStyles = function getButtonStyles() {
    switch (currentLevel) {
      case "l1":
        return {
          padding: "inc40",
          color: "black00",
          background: "none",
          border: "none",
          fontWeight: "500",
          fontFamily: "akzidenz-grotesk-std",
          fontSize: "inc30",
          lineHeight: "inc00",
          flex: "1",
          textAlign: "left"
        };

      case "l2":
        return {
          margin: description ? "inc40" : "inc30",
          marginRight: "inc00",
          marginLeft: "inc00",
          paddingLeft: "inc00",
          color: "black00",
          background: "none",
          border: "none",
          fontWeight: "300",
          fontFamily: "akzidenz-grotesk-std",
          fontSize: "inc30",
          lineHeight: "inc00",
          flex: "1",
          textAlign: "left"
        };

      case "l3":
        return {
          margin: "inc30",
          marginRight: "inc00",
          color: "black00",
          background: "none",
          border: "none",
          fontWeight: "300",
          textDecoration: "none",
          fontSize: "inc30",
          lineHeight: "inc00",
          borderRight: "1px solid ".concat(theme.colors.black80),
          paddingLeft: "inc00"
        };
    }
  };

  var getListItemStyles = function getListItemStyles() {
    switch (currentLevel) {
      case "l1":
        return {
          display: "flex",
          justifyContent: "space-between",
          maxHeight: "200vh",
          transition: "max-height ".concat(theme.motion.mobileNavItemExpand, " ease-in-out"),
          willChange: "max-height",
          overflow: "hidden",
          flexWrap: "wrap"
        };

      case "l2":
        return {
          display: "flex",
          justifyContent: "space-between",
          maxHeight: openParent ? "200vh" : "0",
          transition: "max-height ".concat(theme.motion.mobileNavItemExpand, " ease-in-out"),
          willChange: "max-height",
          overflow: "hidden"
        };

      case "l3":
        return {
          display: "flex",
          justifyContent: "space-between",
          marginLeft: "inc30",
          borderLeft: "1px solid ".concat(theme.colors.black80),
          maxHeight: openParent ? "200vh" : "0",
          transition: "max-height ".concat(theme.motion.mobileNavItemExpand, " ease-in-out"),
          willChange: "max-height",
          overflow: "hidden"
        };
    }
  };

  var levelWrapperRef = useRef(null);
  var column = L1columns === null || L1columns === void 0 ? void 0 : L1columns.sections.flatMap(function (section) {
    return section.columns.map(function (column) {
      return column;
    });
  });
  var cta = L1columns === null || L1columns === void 0 ? void 0 : L1columns.sections.flatMap(function (section) {
    var _section$ctas2 = section.ctas,
        ctas = _section$ctas2 === void 0 ? [] : _section$ctas2;
    return ctas.map(function (cta) {
      return cta;
    });
  });

  var handleOpen = function handleOpen() {
    if (currentLevel === "l3") {
      mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
        title: title,
        position: index,
        href: href || (button === null || button === void 0 ? void 0 : button.href),
        text: description,
        label: title
      }));
    }

    if (onOpen) onOpen();
    setTimeout(function () {
      if ((menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) && (levelWrapperRef === null || levelWrapperRef === void 0 ? void 0 : levelWrapperRef.current)) {
        var sum = levelWrapperRef === null || levelWrapperRef === void 0 ? void 0 : levelWrapperRef.current.offsetTop;

        if (L1Ref === null || L1Ref === void 0 ? void 0 : L1Ref.current) {
          sum = MOBILE_LEVEL_HEIGHT + (levelWrapperRef === null || levelWrapperRef === void 0 ? void 0 : levelWrapperRef.current.offsetTop) + L1Ref.current.offsetTop;
        }

        menuRef.current.scrollTop = sum;
      }
    }, theme.motion.mobileNavItemExpand + ANIMATION_BUFFER);
  };

  useEffect(function () {
    if (!openParent && open && onOpen) onOpen();
  }, [openParent]);
  var L2hasFauxButton = isL2 && button && button.href;
  var L2shouldBeLink = isL2 && (href || L2hasFauxButton);
  var L2hasL3 = isL2 && L2subcolumns && L2subcolumns.length > 0;
  return jsx(Fragment, {
    children: jsxs("li", Object.assign({
      itemProp: "name",
      role: "menuitem",
      sx: _objectSpread({
        flexDirection: "column"
      }, getListItemStyles()),
      ref: levelWrapperRef
    }, {
      children: [jsxs(Box, Object.assign({
        sx: {
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          flexBasis: "100%"
        }
      }, {
        children: [href || isL2 && L2shouldBeLink ? jsxs("a", Object.assign({
          tabIndex: openParent ? 0 : -1,
          href: href || (button === null || button === void 0 ? void 0 : button.href),
          target: target || (button === null || button === void 0 ? void 0 : button.target),
          sx: _objectSpread({
            fontFamily: "akzidenz-grotesk-std",
            flexWrap: "wrap",
            display: "flex",
            flex: "1",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center"
          }, getLinkStyles()),
          onClick: function onClick() {
            mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
              title: title,
              position: index,
              href: href || (button === null || button === void 0 ? void 0 : button.href),
              text: description,
              label: title
            }));
          }
        }, {
          children: [jsxs("span", {
            children: [title, " ", isL2 && jsx("span", Object.assign({
              sx: {
                fontFamily: "Arial, serif",
                color: "green50",
                marginLeft: "inc20"
              }
            }, {
              children: "\u2192"
            }), void 0)]
          }, void 0), isL2 && !button && jsx(Description, {
            description: description
          }, void 0)]
        }), void 0) : jsxs("button", Object.assign({
          tabIndex: currentLevel === "l3" && openParent ? 0 : -1,
          sx: _objectSpread({
            fontFamily: "akzidenz-grotesk-std"
          }, getButtonStyles()),
          onClick: handleOpen
        }, {
          children: [jsx("span", {
            children: title
          }, void 0), isL2 && !button && jsx(Description, {
            description: description
          }, void 0)]
        }), void 0), (isL1 && !href || isL2 && L2hasL3) && jsx("button", Object.assign({
          tabIndex: isL2 && openParent || isL1 ? 0 : -1,
          sx: {
            padding: "inc40",
            background: "none",
            border: "none",
            display: "flex",
            alignItems: "center",
            minHeight: "inc80"
          },
          onClick: handleOpen
        }, {
          children: open ? jsx(CloseIcon, {}, void 0) : jsx(OpenIcon, {}, void 0)
        }), void 0)]
      }), void 0), (column || cta || L2subcolumns) && jsxs("ul", Object.assign({
        itemScope: true,
        itemType: "https://schema.org/SiteNavigationElement",
        role: "menu",
        sx: {
          backgroundColor: "black90",
          position: "relative",
          listStyle: "none",
          margin: "0",
          padding: "0",
          paddingLeft: isL1 && "inc60",
          paddingBottom: isL2 && open && "inc30",
          flexBasis: "100%"
        }
      }, {
        children: [column && column.map(function (_ref32, index) {
          var header = _ref32.header,
              subColumns = _ref32.subColumns,
              button = _ref32.button;
          return jsx(NavLevel, {
            currentLevel: "l2",
            L2subcolumns: subColumns.flat(),
            button: button,
            title: header.title,
            href: header.href,
            target: header.target,
            description: header.description,
            index: index,
            menuRef: menuRef,
            L1Ref: levelWrapperRef,
            openParent: open,
            onOpen: function onOpen() {
              if (activeChild === header.title) setActiveChild("");else {
                mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                  title: header.title,
                  position: index,
                  text: header.description,
                  nonInteraction: 1
                }));
                setActiveChild(header.title);
              }
            },
            open: activeChild === header.title
          }, "navmobile-l2-".concat(header.title, "-").concat(index));
        }), cta && cta.map(function (_ref33, index) {
          var header = _ref33.header,
              button = _ref33.button;
          return jsx(NavLevel, {
            currentLevel: "l2",
            button: button,
            title: header.title,
            href: header.href,
            target: header.target,
            description: header.description,
            index: index,
            menuRef: menuRef,
            L1Ref: levelWrapperRef,
            openParent: open,
            onOpen: function onOpen() {
              if (activeChild === header.title) setActiveChild("");else {
                mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                  title: header.title,
                  position: index,
                  text: header.description
                }));
                setActiveChild(header.title);
              }
            },
            open: activeChild === header.title
          }, "navmobile-l2-".concat(header.title, "-").concat(index));
        }), L2subcolumns && L2subcolumns.map(function (_ref34, index) {
          var title = _ref34.title,
              href = _ref34.href,
              target = _ref34.target;
          return jsx(NavLevel, {
            currentLevel: "l3",
            title: title,
            index: index,
            href: href,
            target: target,
            open: activeChild === title,
            openParent: open,
            L1Ref: levelWrapperRef
          }, "navmobile-l3-".concat(title, "-").concat(index));
        })]
      }), void 0)]
    }), void 0)
  }, void 0);
};

var Mobile = function Mobile(_ref35) {
  var _styles;

  var className = _ref35.className,
      content = _ref35.content,
      shiftableSelector = _ref35.shiftableSelector,
      property = _ref35.property,
      signInUrl = _ref35.signInUrl,
      hideTryFree = _ref35.hideTryFree,
      hideSignIn = _ref35.hideSignIn,
      hideSearch = _ref35.hideSearch,
      _ref35$floraTheme = _ref35.floraTheme,
      floraTheme = _ref35$floraTheme === void 0 ? "default" : _ref35$floraTheme,
      docsBaseUrl = _ref35.docsBaseUrl;

  var _a;

  var options = content.secondary.search ? content.secondary.search.options : [];
  var optionsArray = options.map(function (el) {
    return el.value;
  });
  var defaultOption = ((_a = options.find(function (el) {
    return el.universalKey === (property === null || property === void 0 ? void 0 : property.name);
  })) === null || _a === void 0 ? void 0 : _a.value) || optionsArray[0];

  var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      showMenuLinks = _useState36[0],
      setShowMenuLinks = _useState36[1];

  var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      showMenuSearch = _useState38[0],
      setShowMenuSearch = _useState38[1];

  var _useState39 = useState(defaultOption),
      _useState40 = _slicedToArray(_useState39, 2),
      selectedProperty = _useState40[0],
      setSelectedProperty = _useState40[1];

  var _useState41 = useState(""),
      _useState42 = _slicedToArray(_useState41, 2),
      query = _useState42[0],
      setQuery = _useState42[1];

  var _useState43 = useState(false),
      _useState44 = _slicedToArray(_useState43, 2),
      isAnimating = _useState44[0],
      setIsAnimating = _useState44[1];

  var _useState45 = useState(""),
      _useState46 = _slicedToArray(_useState45, 2),
      activeL1 = _useState46[0],
      setActiveL1 = _useState46[1];

  var menuRef = useRef(null);
  var inputRef = useRef(null);

  var handlePropertySelection = function handlePropertySelection(e) {
    setSelectedProperty(e.currentTarget.value);
    mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
      title: "Select Search Domain",
      text: e.currentTarget.value
    }));
  };

  var startTyping = debounce(function (func, value) {
    if (typeof func === "function") func(value);
  });

  var trackTyping = function trackTyping(query) {
    mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
      title: "Typing Search",
      query: query
    }));
  };

  var handleInputChange = useCallback(function (e) {
    setQuery(e.currentTarget.value);
    startTyping(trackTyping, e.currentTarget.value);
  }, []);
  var overlayStyles = {
    content: '""',
    zIndex: 0,
    opacity: ".6",
    transition: "opacity ".concat(theme.motion.mobileNavPanel - 100),
    willChange: "opacity",
    width: "100%",
    height: "100vh",
    left: "0",
    top: "0",
    position: "absolute",
    backgroundColor: "black"
  };
  var overlayActive = {
    "&:after": _objectSpread(_objectSpread({}, overlayStyles), {}, {
      zIndex: "999",
      opacity: ".6",
      position: "fixed"
    })
  };
  var overlayUnactive = {
    "&:after": _objectSpread(_objectSpread({}, overlayStyles), {}, {
      zIndex: "-1",
      opacity: "0"
    })
  };
  var disableSignIn = hideSignIn || !content.secondary.login;
  var disableSearch = hideSearch || !content.secondary.search;
  var disableTryFree = hideTryFree || !content.secondary.try;
  useEffect(function () {
    var _a;

    setIsAnimating(true);
    if (menuRef) (_a = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("transitionend", function () {
      return setIsAnimating(false);
    }, {
      once: true
    });
    setActiveL1("");
  }, [showMenuLinks, showMenuSearch]);

  var handleSetShowMenuLinks = function handleSetShowMenuLinks() {
    if (!showMenuLinks) {
      setShowMenuSearch(false);
      mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
        title: "Mobile Links",
        nonInteraction: 1
      }));
    }

    setShowMenuLinks(!showMenuLinks);
  };

  var handleSetShowMenuSearch = function handleSetShowMenuSearch() {
    var _a, _b;

    if (!showMenuSearch) {
      setShowMenuLinks(false);
      mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
        title: "Search"
      }));
      (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      /* this is a bit glitchy and hacky,
      but since mobile safari moves the entire window up
      when the keyboard is opened,
      we then need this so that
      the input will be visible when focused
      ref: https://blog.opendigerati.com/the-eccentric-ways-of-ios-safari-with-the-keyboard-b5aa3f34228d
      */

      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 250);
    } else {
      (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
    }

    setShowMenuSearch(!showMenuSearch);
  };

  return jsxs(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: [jsxs(Box, Object.assign({
      sx: {
        backgroundColor: "black00",
        display: "flex",
        alignItems: "center",
        fontFamily: "akzidenz-grotesk-std",
        border: "solid ".concat(theme.colors.border.default),
        borderWidth: "0 0 1px 0",
        fontWeight: "300",
        overflow: "hidden",
        height: "inc60",
        justifyContent: "space-between",
        width: "100%",
        zIndex: "999",
        position: "relative"
      },
      className: className
    }, {
      children: [shiftableSelector ? jsx(Global, {
        styles: (_styles = {}, _defineProperty(_styles, "".concat(shiftableSelector), isAnimating && (showMenuLinks || showMenuSearch) ? _objectSpread({
          left: SHIFT_AMOUNT,
          width: "100%",
          position: "absolute",
          transition: "left ".concat(theme.motion.mobileNavPanel),
          willChange: "left"
        }, overlayActive) : isAnimating && !showMenuLinks && !showMenuSearch ? _objectSpread({
          position: "absolute",
          width: "100%",
          transition: "left ".concat(theme.motion.mobileNavPanel),
          willChange: "left",
          left: 0
        }, overlayUnactive) : _objectSpread({
          left: "0",
          transition: "left ".concat(theme.motion.mobileNavPanel),
          willChange: "left"
        }, overlayUnactive)), _defineProperty(_styles, "body, html", isAnimating && {
          position: "relative",
          width: "100%",
          minHeight: "100vh",
          overflow: "hidden"
        }), _defineProperty(_styles, "@media screen and (min-width: 1024px)", _defineProperty({}, "".concat(shiftableSelector), _objectSpread({
          position: "initial",
          left: 0
        }, overlayUnactive))), _styles)
      }, void 0) : jsx(Global, {
        styles: {
          body: showMenuLinks || showMenuSearch ? _objectSpread(_objectSpread({}, overlayActive), {}, {
            zIndex: 0,
            overflowY: "hidden",
            "@media screen and (min-width: 1024px)": _objectSpread(_objectSpread({}, overlayUnactive), {}, {
              overflowY: "auto"
            })
          }) : _objectSpread(_objectSpread({}, overlayUnactive), {}, {
            zIndex: 0
          })
        }
      }, void 0), jsx(MDBLogo, {
        sx: {
          marginLeft: "inc30",
          display: "flex",
          fontSize: "inc10",
          lineHeight: "inc10"
        },
        variant: ELogoVariant.HORIZONTAL_DEFAULT,
        href: "https://www.mongodb.com",
        imageWidth: "120px",
        theme: floraTheme
      }, void 0), jsxs(Box, Object.assign({
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, {
        children: [disableSearch ? null : jsx("button", Object.assign({
          "aria-label": showMenuSearch ? "Close Search" : "Open Search",
          sx: {
            border: "none",
            background: "none",
            marginRight: "inc40",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            height: "inc60"
          },
          onClick: handleSetShowMenuSearch
        }, {
          children: jsx("img", {
            src: showMenuSearch ? "".concat(ASSETS_URL_PREFIX, "kqi4ky2aj2px1sus5-close.svg?auto=format%252Ccompress") : "".concat(ASSETS_URL_PREFIX, "kqi3wccsoikv7vwbf-icon.svg?auto=format%252Ccompress")
          }, void 0)
        }), void 0), jsx("button", Object.assign({
          "aria-label": showMenuLinks ? "Close Links" : "Open Links",
          sx: {
            border: "none",
            background: "none",
            marginRight: "inc40",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            height: "inc60"
          },
          onClick: handleSetShowMenuLinks
        }, {
          children: jsx("img", {
            src: showMenuLinks ? "".concat(ASSETS_URL_PREFIX, "kqi4ky2aj2px1sus5-close.svg?auto=format%252Ccompress") : "".concat(ASSETS_URL_PREFIX, "kqi3hi5xztie05zgy-Vector%2020.svg?auto=format%252Ccompress")
          }, void 0)
        }), void 0)]
      }), void 0)]
    }), void 0), jsxs(Box, Object.assign({
      role: "menu-wrapper",
      ref: menuRef,
      sx: {
        minHeight: "calc(100% - ".concat(theme.sizes.inc60, ")"),
        height: "calc(100vh - ".concat(theme.sizes.inc60, ")"),
        backgroundColor: "black80",
        width: SHIFT_AMOUNT,
        maxWidth: "99vw",
        position: "absolute",
        top: "inc80",
        left: showMenuLinks || showMenuSearch ? "0" : "-".concat(SHIFT_AMOUNT),
        transition: "left ".concat(theme.motion.mobileNavPanel),
        willChange: "left",
        zIndex: "1",
        display: ["flex", null, null, "none"],
        flexDirection: "column",
        overflowY: "auto",
        scrollBehavior: "smooth",
        border: "solid ".concat(theme.colors.black50),
        borderWidth: "0 1px 0 0",
        boxShadow: "level04"
      }
    }, {
      children: [showMenuLinks && jsxs("ul", Object.assign({
        itemScope: true,
        itemType: "https://schema.org/SiteNavigationElement",
        role: "menu",
        sx: {
          listStyle: "none",
          margin: "0",
          padding: "0"
        }
      }, {
        children: [content.primary.map(function (_ref36, index) {
          var title = _ref36.title,
              href = _ref36.href,
              dropdown = _ref36.dropdown,
              target = _ref36.target;
          return jsx(NavLevel, {
            currentLevel: "l1",
            href: href,
            target: target,
            title: title,
            index: index,
            L1columns: dropdown,
            menuRef: menuRef,
            onOpen: function onOpen() {
              if (activeL1 === title) setActiveL1("");else {
                mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                  title: title,
                  position: index,
                  nonInteraction: 1
                }));
                setActiveL1(title);
              }
            },
            open: activeL1 === title
          }, "navmobile-l1-".concat(title, "-").concat(index));
        }), jsx(Divider$1, {
          color: "".concat(theme.colors.black70)
        }, void 0), jsxs(Box, Object.assign({
          sx: {
            display: "flex",
            padding: "inc40",
            paddingBottom: "104px"
          }
        }, {
          children: [disableTryFree ? null : jsx(ButtonWrapper, Object.assign({
            theme: "default",
            variant: "primary",
            inverse: true,
            customWrapperStyles: {
              flex: "1",
              marginRight: "inc30",
              textAlign: "center"
            },
            customStyles: {
              width: "unset"
            },
            href: content.secondary.try.href,
            onClick: function onClick() {
              mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                title: content.secondary.try.title,
                href: content.secondary.try.href,
                label: content.secondary.try.title
              }));
            }
          }, {
            children: content.secondary.try.title
          }), void 0), disableSignIn ? null : jsx(ButtonWrapper, Object.assign({
            theme: "default",
            variant: "secondary",
            inverse: true,
            customWrapperStyles: {
              flex: "1",
              textAlign: "center"
            },
            customStyles: {
              width: "unset"
            },
            href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
            onClick: function onClick() {
              mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                title: content.secondary.login.title,
                href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
                label: content.secondary.login.title
              }));
            }
          }, {
            children: content.secondary.login.title
          }), void 0)]
        }), void 0)]
      }), void 0), disableSearch ? null : jsxs("form", Object.assign({
        role: "search",
        sx: {
          padding: showMenuSearch ? "inc40" : "inc00",
          maxHeight: showMenuSearch ? 4000 : 0,
          overflow: "hidden"
        },
        method: "GET",
        action: selectedProperty === "Blog" ? getSearchURL(selectedProperty, options, docsBaseUrl) + "/" + query : getSearchURL(selectedProperty, options, docsBaseUrl),
        onSubmit: function onSubmit() {
          mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
            title: "Submit Search",
            query: query
          }));
        }
      }, {
        children: [jsx(TextInput, {
          ref: inputRef,
          theme: "legacy",
          inverse: true,
          placeholder: getPlaceholderText(selectedProperty, options),
          inputStyles: {
            width: "100%"
          },
          wrapperStyles: {
            width: "100%"
          },
          value: query,
          onChange: handleInputChange
        }, void 0), jsxs(Box, Object.assign({
          sx: {
            marginTop: "inc20",
            display: "flex",
            justifyContent: "space-between"
          }
        }, {
          children: [jsx("select", Object.assign({
            className: "select-overlay",
            id: "filter-select",
            value: selectedProperty,
            onChange: handlePropertySelection,
            onClick: function onClick() {
              mdbTrack(ETrackingEvents.SEARCH, _objectSpread(_objectSpread({}, COMMON_NAVIGATION_TRACKING_PROPS), {}, {
                title: "Open Search Domain Selector"
              }));
            },
            sx: {
              padding: "14px 8px",
              background: "transparent",
              color: "".concat(theme.colors.input.inverse.text),
              borderColor: "black50",
              width: "214px",
              fontFamily: "akzidenz-grotesk-std",
              fontSize: "inc20",
              fontWeight: "300",
              borderRadius: "buttons"
            }
          }, {
            children: optionsArray.map(function (option) {
              return jsx("option", Object.assign({
                value: option
              }, {
                children: option
              }), option);
            })
          }), void 0), getQueryStrings(selectedProperty, query, options, metadataParams(selectedProperty, property)).map(function (querystring) {
            return querystring.param && jsx("input", {
              type: "hidden",
              id: querystring.param,
              name: querystring.param,
              value: querystring.value
            }, "navsearch-form-".concat(querystring.param));
          }), jsx(ButtonWrapper, Object.assign({
            theme: "default",
            variant: "primary",
            "aria-label": "Submit Search",
            type: "submit",
            sx: _objectSpread(_objectSpread({}, floraTheme === "legacy" && {
              fontFamily: "akzidenz-grotesk-std",
              backgroundColor: "green40",
              border: "none",
              borderRadius: "buttons",
              color: "black90"
            }), {}, {
              padding: "inc30",
              marginLeft: "inc10",
              fontSize: "inc20",
              textAlign: "center"
            }),
            customStyles: {
              padding: "16px 14px"
            }
          }, {
            children: content.secondary.search.submit
          }), void 0)]
        }), void 0)]
      }), void 0)]
    }), void 0)]
  }), void 0);
};

var NavBar = function NavBar(_ref37) {
  var className = _ref37.className,
      content = _ref37.content,
      shiftableSelector = _ref37.shiftableSelector,
      width = _ref37.width,
      position = _ref37.position,
      offsetTop = _ref37.offsetTop,
      property = _ref37.property,
      signInUrl = _ref37.signInUrl,
      _ref37$hideTryFree = _ref37.hideTryFree,
      hideTryFree = _ref37$hideTryFree === void 0 ? false : _ref37$hideTryFree,
      _ref37$hideSignIn = _ref37.hideSignIn,
      hideSignIn = _ref37$hideSignIn === void 0 ? false : _ref37$hideSignIn,
      _ref37$hideSearch = _ref37.hideSearch,
      hideSearch = _ref37$hideSearch === void 0 ? false : _ref37$hideSearch,
      _ref37$floraTheme = _ref37.floraTheme,
      floraTheme = _ref37$floraTheme === void 0 ? "default" : _ref37$floraTheme,
      docsBaseUrl = _ref37.docsBaseUrl;
  return jsxs(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: [jsx(Globals, {
      legacy: true
    }, void 0), jsx(Globals, {}, void 0), jsxs("nav", Object.assign({
      role: "navigation",
      className: className,
      sx: {
        width: width || "100%",
        position: position || "fixed",
        top: offsetTop || "0",
        left: "0",
        zIndex: "1"
      }
    }, {
      children: [jsx(Desktop, {
        sx: {
          display: ["none", null, null, "flex"]
        },
        content: content,
        property: property,
        signInUrl: signInUrl,
        hideTryFree: hideTryFree,
        hideSignIn: hideSignIn,
        hideSearch: hideSearch,
        floraTheme: floraTheme,
        docsBaseUrl: docsBaseUrl
      }, void 0), jsx(Mobile, {
        sx: {
          display: ["flex", null, null, "none"]
        },
        content: content,
        shiftableSelector: shiftableSelector,
        property: property,
        signInUrl: signInUrl,
        hideTryFree: hideTryFree,
        hideSignIn: hideSignIn,
        hideSearch: hideSearch,
        floraTheme: floraTheme,
        docsBaseUrl: docsBaseUrl
      }, void 0)]
    }), void 0)]
  }), void 0);
};

var LinkID;

(function (LinkID) {
  LinkID["CookiePreference"] = "manage-cookies";
})(LinkID || (LinkID = {}));

var useGeoIP = function useGeoIP(cb) {
  var maxCalls = 3;
  var count = 0;
  useEffect(function () {
    var getGeoIP = function getGeoIP() {
      try {
        if (window && window.oneTrustLocation) {
          cb({
            country: window.oneTrustLocation
          });
          return;
        }

        if (count === maxCalls) {
          return;
        } else {
          count++;
          setTimeout(getGeoIP, 1000);
        }
      } catch (e) {
        console.error(e);
        cb({
          country: ""
        });
      }
    };

    getGeoIP();
  }, []);
};

var localeMap = {
  English: "en-us",
  Português: "pt-br",
  Español: "es",
  한국어: "ko-kr",
  日本語: "ja-jp",
  Italiano: "it-it",
  Deutsch: "de-de",
  Français: "fr-fr",
  简体中文: "zh-cn"
};

var Footer = function Footer(_ref38) {
  var className = _ref38.className,
      content = _ref38.content,
      onSelectLocale = _ref38.onSelectLocale,
      locale = _ref38.locale,
      hideLocale = _ref38.hideLocale,
      floraTheme = _ref38.floraTheme;

  var _useState47 = useState(false),
      _useState48 = _slicedToArray(_useState47, 2),
      shouldShowVATLink = _useState48[0],
      setShouldShowVATLink = _useState48[1];

  var manageCookieLinks = content.sections[1].links.filter(function (link) {
    return link.id === LinkID.CookiePreference;
  });

  var _useState49 = useState(manageCookieLinks.length === 0),
      _useState50 = _slicedToArray(_useState49, 2),
      showCookiePrefLink = _useState50[0],
      setShowCookiePrefLink = _useState50[1];

  var actualLocale = Object.keys(localeMap).find(function (key) {
    return localeMap[key] === locale;
  }) || "English";
  useEffect(function () {
    var _a;

    var OptanonConsentCookie = document.cookie.split("; ").find(function (row) {
      return row.startsWith("OptanonConsent");
    });

    if (((_a = window.Optanon) === null || _a === void 0 ? void 0 : _a.useGeoLocationService) || OptanonConsentCookie) {
      setShowCookiePrefLink(true);
    }
  }, []);
  useGeoIP(function (getGeolocationData) {
    var isSaudiArabiaUser = getGeolocationData && getGeolocationData.country === "SA";
    setShouldShowVATLink(isSaudiArabiaUser);
  });
  return jsxs(ThemeProvider, Object.assign({
    theme: theme
  }, {
    children: [jsx(Globals, {
      legacy: true
    }, void 0), jsx("footer", Object.assign({
      className: className,
      sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: theme.colors.black90,
        color: theme.colors.black00
      }
    }, {
      children: jsxs(Box, Object.assign({
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: ["column", null, "row"],
          justifyContent: "space-between",
          maxWidth: "1024px",
          paddingTop: theme.space.inc90,
          paddingBottom: theme.space.inc90,
          paddingLeft: theme.space.inc40,
          paddingRight: theme.space.inc40
        }
      }, {
        children: [jsxs(Box, Object.assign({
          sx: {
            flexBasis: "25%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            marginBottom: [theme.space.inc60, null, theme.space.inc00]
          }
        }, {
          children: [jsxs(Box, Object.assign({
            sx: {
              display: ["grid", null, "block"],
              gridTemplateColumns: "1fr 1fr",
              flexDirection: ["row", null, "column"],
              alignItems: ["center", null, "flex-start"],
              justifyContent: "space-between"
            }
          }, {
            children: [jsx(Box, Object.assign({
              sx: {
                maxWidth: ["120px", null, null, "150px"]
              }
            }, {
              children: jsx(MDBLogo, {
                sx: {
                  fontSize: "inc10",
                  lineHeight: "inc10"
                },
                theme: floraTheme,
                variant: ELogoVariant.HORIZONTAL_INVERSE,
                imageWidth: "100%",
                href: "https://www.mongodb.com"
              }, void 0)
            }), void 0), !hideLocale && jsxs(Box, Object.assign({
              sx: {
                display: "flex",
                marginTop: [theme.space.inc00, null, theme.space.inc40]
              }
            }, {
              children: [jsx("img", {
                src: "https://webimages.mongodb.com/_com_assets/cms/kr6zmbrgbwlke2l97-atlas-global-deployments.svg?auto=format%252Ccompress"
              }, void 0), jsx(Select, {
                theme: "legacy",
                invalid: false,
                variant: "default",
                options: Object.keys(localeMap),
                inverse: true,
                border: "none",
                width: "min-content",
                value: actualLocale,
                menuPlacement: "auto",
                onOpen: function onOpen() {
                  mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_FOOTER_TRACKING_PROPS), {}, {
                    title: "Locale Selector Open"
                  }));
                },
                onSelect: function onSelect(value) {
                  mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_FOOTER_TRACKING_PROPS), {}, {
                    title: "Locale Selector Selected",
                    locale: value
                  }));
                  if (onSelectLocale) onSelectLocale(localeMap[value]);
                }
              }, void 0)]
            }), void 0)]
          }), void 0), jsx(Box, Object.assign({
            sx: {
              display: ["none", null, "block"],
              fontFamily: "akzidenz-grotesk-std",
              fontWeight: "300",
              fontSize: theme.fontSizes.inc00,
              color: theme.colors.black30
            }
          }, {
            children: content.copyright
          }), void 0)]
        }), void 0), content.sections.map(function (section, index) {
          return jsxs(Box, Object.assign({
            sx: {
              flexBasis: "25%",
              marginTop: [theme.space.inc40, null, theme.space.inc00]
            }
          }, {
            children: [jsx("p", Object.assign({
              sx: {
                fontFamily: "akzidenz-grotesk-std",
                fontWeight: "500",
                fontSize: "inc20",
                marginBottom: theme.space.inc40,
                color: "black00",
                marginTop: ["inc00", null, "initial"]
              }
            }, {
              children: section.title
            }), void 0), jsx("ul", Object.assign({
              sx: {
                listStyle: "none",
                margin: "0",
                padding: "0",
                display: ["grid", null, "block"],
                gridTemplateColumns: "1fr 1fr"
              }
            }, {
              children: section.links.filter(function (link) {
                return link.id !== LinkID.CookiePreference || showCookiePrefLink;
              }).map(function (link, index) {
                var isDefaultLink = !link.hide; // 'hide' field only exists on VAT link

                var isSAUser = link.title === "Saudi Arabian VAT Certificate" && shouldShowVATLink;

                if (isDefaultLink || isSAUser) {
                  return jsx("li", Object.assign({
                    sx: {
                      marginBottom: "inc40"
                    }
                  }, {
                    children: jsxs("a", Object.assign({
                      sx: {
                        color: "black00",
                        textDecoration: "none",
                        fontFamily: "akzidenz-grotesk-std",
                        fontWeight: "300",
                        fontSize: "inc10",
                        lineHeight: "inc30",
                        display: "flex",
                        alignItems: "center"
                      },
                      href: link.href,
                      target: link.target,
                      rel: "noreferrer noopener",
                      download: isSAUser && "MongoDB Saudi Arabian VAT Certificate",
                      onClick: function onClick(evt) {
                        var _a;

                        if (link.id === LinkID.CookiePreference) {
                          evt.preventDefault();
                          (_a = window.Optanon) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
                        }

                        mdbTrack(ETrackingEvents.LINK_CLICK, _objectSpread(_objectSpread({}, COMMON_FOOTER_TRACKING_PROPS), {}, {
                          title: link.title,
                          href: link.href,
                          label: link.title,
                          position: index
                        }));
                      }
                    }, {
                      children: [link.icon && jsx("img", {
                        sx: {
                          marginRight: "inc30"
                        },
                        src: link.icon
                      }, void 0), link.title]
                    }), void 0)
                  }), "footer-section-link-".concat(link.title, "-").concat(index));
                }
              })
            }), void 0)]
          }), "footer-section-".concat(section.title, "-").concat(index));
        }), jsx(Box, Object.assign({
          sx: {
            display: ["block", null, "none"],
            fontFamily: "akzidenz-grotesk-std",
            fontWeight: "300",
            fontSize: theme.fontSizes.inc00,
            color: theme.colors.black30,
            marginTop: theme.space.inc40
          }
        }, {
          children: content.copyright
        }), void 0)]
      }), void 0)
    }), void 0)]
  }), void 0);
};

var defaultLanguage = "en-us";

var UnifiedNav = function UnifiedNav(props) {
  var _a;

  var selectedLocale = ((_a = props.locale) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || defaultLanguage;
  var data = getContent(props.docsBaseUrl);
  var selectedContent = data[selectedLocale] || data[defaultLanguage];
  return jsx(NavBar, Object.assign({
    content: props.replacementContent || selectedContent.nav
  }, props), void 0);
};

var UnifiedFooter = function UnifiedFooter(_ref39) {
  var onSelectLocale = _ref39.onSelectLocale,
      locale = _ref39.locale,
      hideLocale = _ref39.hideLocale,
      floraTheme = _ref39.floraTheme;
  var selectedLocale = (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || defaultLanguage;
  var data = getContent();
  var selectedContent = data[selectedLocale] || data[defaultLanguage];
  return jsx(Footer, {
    hideLocale: hideLocale,
    locale: selectedLocale,
    content: selectedContent.footer,
    onSelectLocale: onSelectLocale,
    floraTheme: floraTheme
  }, void 0);
};

export { UnifiedFooter, UnifiedNav };